import React, {useCallback, useEffect, useRef, useState} from 'react';
import '../../../css/web/AdminReceiptList.css';
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import axios from '../../../services/axiosInstance';
import AdminPageEvent from "./AdminPageEvent";
import MsgSelectModal from "../modal/MsgSelectModal";
import MsgCheckModal from "../modal/MsgCheckModal";
import {useWebSocket} from "../../../services/WebsocketContext";
import CommonLoading from "../modal/CommonLoading";
import { saveAs } from 'file-saver';
import * as ExcelJS from "exceljs";

function AdminReceiptList() {

    /** region DataTable */

    const [ordReceiptData, setOrdReceiptData] = useState([]);
    const [selectedShipCompany, setSelectedShipCompany] = useState('');

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');
    const [prodToggleSt, setProdToggleSt] = useState({});
    const [recToggleSt, setRecToggleSt] = useState({});
    const menuRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const [adminInfo, setAdminInfo] = useState([]);
    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setAdminInfo(response.data[0])
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
    }, [])


    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [adminInfo.mbNum, isConnected, stompClient]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setRecToggleSt({});
                setProdToggleSt({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleMenu = (clickedSeqNum, menuType) => {
        if (menuType === 'rec') {
            setRecToggleSt(prevRecStates => {
                let newStates = {...prevRecStates};
                Object.keys(newStates).forEach(key => {
                    newStates[key] = false;
                });
                newStates[clickedSeqNum] = !prevRecStates[clickedSeqNum];
                return newStates;
            });
            setProdToggleSt({});
        } else if (menuType === 'prod') {
            setProdToggleSt(prevProdStates => {
                let newStates = {...prevProdStates};
                Object.keys(newStates).forEach(key => {
                    newStates[key] = false;
                });
                newStates[clickedSeqNum] = !prevProdStates[clickedSeqNum];
                return newStates;
            });
            setRecToggleSt({});
        }
    };

    //region Pagination

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(20);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const pageChange = (currentPage) => {
        setCurrentPage(currentPage);
    };
    const handleSelectChange = (e) => {
        setperPg(parseInt(e.target.value));
        setCurrentPage(1);
    };

    //endregion

    //region CheckBox

    const [checked, setChecked] = useState([]);
    const [shipcoChecked, setShipcoChecked] = useState([]);

    const checkBoxChange = (id, dvType) => {
        setChecked((prevSelectedData) => {
            if (prevSelectedData.includes(id)) {
                setShipcoChecked(prev => prev.filter(item => item.id !== id));
                return prevSelectedData.filter(item => item !== id);
            } else {
                setShipcoChecked(prev => [...prev, {id, dvType}]);
                return [...prevSelectedData, id];
            }
        });
    };

    const allcheckBoxChange = (e) => {
        const filteredData = ordReceiptData.filter(
            (cData) => selectedShipCompany === '' || cData.dvType === selectedShipCompany
        );

        if (e.target.checked) {
            const allIds = filteredData.map(item => item.seqNum);
            const allTypes = filteredData.map(item => ({id: item.seqNum, dvType: item.dvType}));
            setChecked(allIds);
            setShipcoChecked(allTypes);
        } else {
            setChecked(prev => prev.filter(id => !filteredData.some(item => item.seqNum === id)));
            setShipcoChecked(prev => prev.filter(item => !filteredData.some(data => data.seqNum === item.id)));
        }
    };

    // const filteredData = ordReceiptData.filter(
    //     (cData) => selectedShipCompany === '' || cData.dvType === selectedShipCompany
    // );

    const filteredData = ordReceiptData.filter((cData) => {
        // "배송사선택" (전체)를 선택한 경우
        if (selectedShipCompany === '') {
            return true;
        }
        // "FedEx+FedEx-E"를 선택한 경우
        if (selectedShipCompany === 'FedEx_Group') {
            return ['D01', 'D16'].includes(cData.dvType);
        }
        // "UPS+UPS-E"를 선택한 경우
        if (selectedShipCompany === 'UPS_Group') {
            return ['D11', 'D17'].includes(cData.dvType);
        }
        // 그 외 다른 배송사를 선택한 경우
        return cData.dvType === selectedShipCompany;
    });

    const currentItems = filteredData.slice(indexOfFirst, indexOfLast);

    //endregion

    // region Alert

    const [alertShow, setAlertShow] = useState(false);
    const [alertShowFedex, setAlertShowFedex] = useState(false);
    const [alertShowUps, setAlertShowUps] = useState(false);
    const [alertShowEms, setAlertShowEms] = useState(false);

    const [nonSelectOrderSt, setNonSelectOrderSt] = useState(false);
    const [nonEmsDataSt, setNonEmsDataSt] = useState(false);
    const [nonSPackDataSt, setNonSPackDataSt] = useState(false);
    const [nonSeaDataSt, setNonSeaDataSt] = useState(false);
    const [nonFedexDataSt, setNonFedexDataSt] = useState(false);
    const [nonUpsDataSt, setNonUpsDataSt] = useState(false);

    const msgConfirmData1 = "주문정보를 출고처리 하시겠습니까??";
    const msgConfirmData2 = "선택된 주문정보가 출고완료 됩니다.";
    const msgConfirmEmsData1 = "EMS 주문정보를 출고처리 하시겠습니까??";
    const msgConfirmEmsData2 = "선택된 주문정보가 출고완료 됩니다.";
    const msgConfirmUpsData1 = "UPS 주문정보를 출고처리 하시겠습니까??";
    const msgConfirmFedexData1 = "FEDEX 주문정보를 출고처리 하시겠습니까??";

    const alertTariff = (() => {
        if (checked.length === 0) {
            setNonSelectOrderSt(true);
            return;
        }
        openTariffModal();
    })

    const alertWaybill = (() => {
        if (checked.length === 0) {
            setNonSelectOrderSt(true);
            return;
        }
        setAlertShow(true)
    })

    const alertFedexApi = () => {
        if (checked.length === 0) {
            setNonSelectOrderSt(true);
            return;
        }

        const hasNonFedexData = shipcoChecked.some(item => (item.dvType !== "D01" && item.dvType !== "D16"));

        if (hasNonFedexData) {
            setNonFedexDataSt(true);
        } else {
            setAlertShowFedex(true);
        }
    };

    const alertUpsApi = () => {
        if (checked.length === 0) {
            setNonSelectOrderSt(true);
            return;
        }

        const hasNonUpsData = shipcoChecked.some(item => (item.dvType !== "D11" && item.dvType !== "D17"));

        if (hasNonUpsData) {
            setNonUpsDataSt(true);
        } else {
            setAlertShowUps(true);
        }
    };

    const alertPostOfficeApi = () => {
        if (checked.length === 0) {
            setNonSelectOrderSt(true);
            return;
        }

        const hasNonEmsData = shipcoChecked.some(item => (item.dvType !== "D02" && item.dvType !== "D13" && item.dvType !== "D15"));

        if (hasNonEmsData) {
            setNonEmsDataSt(true);
        } else {
            setAlertShowEms(true);
        }
    };

    const closeNonSelectOrderSt = (() => {
        setNonSelectOrderSt(false);
    })
    const closeNonEmsDataSt = (() => {
        setNonEmsDataSt(false);
    })
    const closeNonSPackDataSt = (() => {
        setNonSPackDataSt(false);
    })
    const closeNonSeaDataSt = (() => {
        setNonSeaDataSt(false);
    })
    const closeNonFedexDataSt = (() => {
        setNonFedexDataSt(false);
    })
    const closeNonUpsDataSt = (() => {
        setNonUpsDataSt(false);
    })

    const modalCancel1 = useCallback(() => {
        setAlertShow(false);
    })

    const modalCancelFedex = useCallback(() => {
        setAlertShowFedex(false);
    })

    const modalCancelUps = useCallback(() => {
        setAlertShowUps(false);
    })

    const modalCancelEms = useCallback(() => {
        setAlertShowEms(false);
    })

    // endregion

    useEffect(() => {
        window.scrollTo(0, 910);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const handleInputWaybillChange = (e, seqNum) => {
        const updatedData = ordReceiptData.map(data => {
            if (data.seqNum === seqNum) {
                return {...data, shipInfoDTO: {...data.shipInfoDTO, outWayNum: e.target.value}};
            }
            return data;
        });
        setOrdReceiptData(updatedData);
    };

    const NumberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const handleInputPriceChange = (e, seqNum) => {
        const value = e.target.value.replace(/,/g, '');
        const formattedValue = NumberWithCommas(value);

        const updatedData = ordReceiptData.map(data => {
            if (data.seqNum === seqNum) {
                return {
                    ...data,
                    shipInfoDTO: {
                        ...data.shipInfoDTO,
                        shipPrice: formattedValue
                    }
                };
            }
            return data;
        });
        setOrdReceiptData(updatedData);
    };

    useEffect(() => {
        ordReceiptSelect();
    }, []);

    let WayModal;
    const width = 850;
    const height = 900;
    const left = (window.innerWidth / 2) - (width / 2);
    const top = (window.innerHeight / 2) - (height / 2);

    const openTariffModal = () => {
        if (checked.length === 0) {
            alert('주문을 선택하세요.');
            return;
        }

        const selectedData = ordReceiptData.filter(row => checked.includes(row.seqNum));
        localStorage.setItem('ordReceiptData', JSON.stringify(selectedData));

        if (WayModal && !WayModal.closed) {
            WayModal.location.href = '/btcorpad/btad-TariffReg';
            WayModal.focus();
        } else {
            WayModal = window.open('/btcorpad/btad-TariffReg', '_blank', `width=${width},height=${height},left=${left},top= ${top}, scrollbars=yes`);
        }
    };
    /** endregion */

    /** region Event */

    const ordReceiptSelect = (() => {
        axios({
            method: 'get',
            url: '/order/selectOrdReceiptList',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setOrdReceiptData(response.data);
                // ✨ 모든 조회 및 접수 성공 후 배송사 데이터 체크박스 리셋
                setChecked([]);
                setShipcoChecked([]);
            })
            .catch((error) => {
                console.log("실패: ", error);
            })
    })

    const shipInfoData = ordReceiptData
        .filter((chkData) => checked.includes(chkData.seqNum))
        .map((entry) => ({
            seqNum: entry.shipInfoDTO.seqNum,
            outWayNum: entry.shipInfoDTO.outWayNum,
            shipPrice: parseInt((entry.shipInfoDTO.shipPrice || '0').replace(/,/g, ''), 10),
            inputValue: entry.inputValue,
        }));

    const orderdtData = ordReceiptData.filter((chkData) => checked.includes(chkData.seqNum)).map(data => ({
        seqnum: data.orderdtDTO.seqnum
    }));

    const payInfoData = ordReceiptData.filter((chkData) => checked.includes(chkData.seqNum)).map(data => ({
        seqNum: data.seqNum
    }));

    const outWaybillUpdate = () => {
        if (isLoading) return;

        setIsLoading(true);

        if (checked.length === 0) {
            setAlertShow(false);
            alert('주문을 선택하세요');
            return;
        }
        const updateRequest = {
            shipInfoDTOList: shipInfoData,
            orderdtDTOList: orderdtData,
            payinfoDTOList: payInfoData
        };

        axios.post('/order/ordWaybillUpdate', updateRequest, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            }
        })
            .then(async (response) => {
                const data = response.data;
                if (subscribe) {
                    for (const payinfo of data) {
                        await sendMessage(payinfo);
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: payinfo.orderdtDTO.memberDTO.mbNum}));
                    }
                }
                setAlertShow(false);
                // 추후 재조회가 아닌 접수완료 후 출고완료된 payinfo.seqNum들 반환해서 ordReceiptData에서 필터해야 함
                ordReceiptSelect();
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    const [poCustNo, setPoCustNo] = useState(null);
    const selectedPostOfficeCustNo = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/selectedPostOfficeCustNo');
            setPoCustNo(response.data);
        } catch (error) {
            console.error('Failed to Selected P.O custno:', error);
        }
    };

    const [emsApprNo, setEmsApprNo] = useState(null);
    const selectedEmsApprNo = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/selectedEmsApprNo');
            setEmsApprNo(response.data);
        } catch (error) {
            console.error('Failed to Selected EMS apprno:', error);
        }
    };

    const [kpackApprNo, setKpackApprNo] = useState(null);
    const selectedKpackApprNo = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/selectedKpackApprNo');
            setKpackApprNo(response.data);
        } catch (error) {
            console.error('Failed to Selected K-Pack apprno:', error);
        }
    };

    useEffect(() => {
        selectedPostOfficeCustNo();
        selectedEmsApprNo();
        selectedKpackApprNo();
    }, []);


    // EMS API
    const regData = ordReceiptData.filter((apiData) => checked.includes(apiData.seqNum)).map((apiData) => {
        const isInsuranceOverZero = apiData.emsInsrFee > 0;
        const boyn = isInsuranceOverZero ? 'Y' : 'N';

        let {address1, address2, address3} = apiData.appRecDTO;
        let city = apiData.appRecDTO.city || '';

        // // 인도네시아 - API 호출 시 필수입력국가가 아니라서 오류발생
        // const countryCode = apiData.appRecDTO.countryDTO?.countryCode || '';
        // const rawTaxId = apiData.appRecDTO.taxid || '';
        // let cdremarkValue = ''; // 인도네시아 TaxID
        // if (countryCode === 'ID' && rawTaxId.trim().length > 0) {
        //     cdremarkValue = rawTaxId.trim();
        // }

        // null 또는 undefined 방지를 위해 빈 문자열로 초기화
        address1 = address1 || '';
        address2 = address2 || '';
        address3 = address3 || '';
        city = city || '';

        // 기표지 출력순서: LIMIT_R3 -> LIMIT_R2 -> LIMIT_R1
        const LIMIT_R3 = 200; // receiveaddr3 (주소1) - 최대 200자
        const LIMIT_R2 = 50;  // receiveaddr2 (주소2) - 최대 50자
        const LIMIT_R1 = 50;  // receiveaddr1 (주소3) - 최대 50자

        // 도시명(city) 위치 우선 배정
        // EMS API 필드에 매핑될 "원본" 데이터를 먼저 결정합니다.
        let r1_source = ''; // receiveaddr1의 원본 (address3 또는 city+address3)
        let r3_source = ''; // receiveaddr3의 원본 (address1 또는 address1+city)

        if (city) {
            const combined_city_addr1 = (address3 + ' ' + city).trim();
            if (combined_city_addr1.length <= LIMIT_R1) {
                // 50자 미만 시, 도시명을 receiveaddr1에 우선 삽입 = 도시명이 마지막에 표시
                r1_source = combined_city_addr1;
                r3_source = address1;
            } else {
                // 50자 초과 시, 도시명 전체를 receiveaddr3로 이동 = 도시명이 주소1 다음에 표시
                r1_source = address3; // receiveaddr1은 address3만 가짐
                r3_source = (address1 + ' ' + city).trim();
            }
        } else {
            // 도시명이 없는 경우
            r1_source = address3;
            r3_source = address1;
        }

        const currentCountryCode = apiData.appRecDTO.countryDTO?.countryCode || '';
        const currentTaxId = apiData.appRecDTO.taxid || '';
        // 국가코드가 ID(인도네시아)이고 TaxID가 존재할 경우
        if (currentCountryCode === 'ID' && currentTaxId.trim().length > 0) {
            // 주소1 앞에 우선적으로 NIK와 함께 삽입
            r3_source = `NIK ${currentTaxId.trim()} ${r3_source}`;
        }

        // receiveaddr2는 address2가 기본
        const r2_source = address2;

        // EMS API로 전송될 최종 변수
        let receiveaddr1 = '';
        let receiveaddr2 = '';
        let receiveaddr3 = '';

        // R3 (receiveaddr3 / 주소1) 처리
        let overflow_from_r3 = '';
        if (r3_source.length > LIMIT_R3) {
            receiveaddr3 = r3_source.substring(0, LIMIT_R3);
            overflow_from_r3 = r3_source.substring(LIMIT_R3); // 초과분
        } else {
            receiveaddr3 = r3_source;
        }

        // R2 (receiveaddr2 / 주소2) 처리
        // R3의 초과분을 R2 앞부분에 추가
        const combined_r2 = (overflow_from_r3 + ' ' + r2_source).trim();
        let overflow_from_r2 = '';
        if (combined_r2.length > LIMIT_R2) {
            receiveaddr2 = combined_r2.substring(0, LIMIT_R2);
            overflow_from_r2 = combined_r2.substring(LIMIT_R2); // 초과분
        } else {
            receiveaddr2 = combined_r2;
        }

        // R1 (receiveaddr1 / 주소3) 처리
        // R2의 초과분을 R1 앞부분에 추가
        const combined_r1 = (overflow_from_r2 + ' ' + r1_source).trim();
        if (combined_r1.length > LIMIT_R1) {
            receiveaddr1 = combined_r1.substring(0, LIMIT_R1); // 최종 초과분은 잘림
        } else {
            receiveaddr1 = combined_r1;
        }

        const isEms = apiData.dvType === "D02";
        const isEmsPremium = apiData.dvType === "D15";
        const isKpack = apiData.dvType === "D13";

        const premiumcd = isEms ? '31' : isEmsPremium ? '32' : isKpack ? '14' : '';
        const division = (isEms || isEmsPremium) ? 'em' : isKpack ? 'rl' : '';

        return {
            custno: poCustNo,
            apprno: isKpack ? kpackApprNo : emsApprNo,
            premiumcd: premiumcd,
            em_ee: division,
            countrycd: apiData.appRecDTO.countryDTO.countryCode,
            totweight: Math.round(apiData.shipInfoDTO.weight * 1000),
            boyn: boyn,
            boprc: apiData.emsInsrFee,
            // nextdayreserveyn: 'Y',
            // reqhhmi: 1159,
            orderno: apiData.orderdtDTO.orderNumber,
            // premiumexportyn: 'N', // 수출면장 - 프리미엄(비서류)만 가능 / EMS에서는 N과 Y 모두 오류
            // cdremark: cdremarkValue, // 인도네시아 - API 호출 시 필수입력국가가 아니라서 오류발생
            sender: 'Btorage',
            senderzipcode: '12722',
            senderaddr1: '42beon-gill, 1floor, Gonjiam-eup 32-15',
            senderaddr2: 'Yeongok-gil,',
            senderaddr3: 'Gwangju-si, Gyeonggi-do',
            sendertelno1: '82',
            sendertelno2: '070',
            sendertelno3: '4131',
            sendertelno4: '4180',
            sendermobile1: '82',
            sendermobile2: '010',
            sendermobile3: '3338',
            sendermobile4: '9354',
            senderemail: 'help@btorage.com',
            // snd_message: '',

            receivename: apiData.appRecDTO.recname,
            receivezipcode: apiData.appRecDTO.zipcode,
            // 기표지 출력순서: receiveaddr3(주소1/Max50) -> receiveaddr2(주소2/Max50) -> receiveaddr1(주소3+도시명/Max200)
            receiveaddr1: receiveaddr1,
            receiveaddr2: receiveaddr2,
            receiveaddr3: receiveaddr3,
            receivetelno: apiData.appRecDTO.telnum, //전체
            receivemail: apiData.orderdtDTO.memberDTO.id,

            orderprsnzipcd: '12722',
            orderprsnaddr1: '42beon-gill, 1floor, Gonjiam-eup 32-15, Yeongok-gil',
            orderprsnaddr2: 'Gwangju, Gyeonggi-do,',
            orderprsnnm: "Btorage",
            orderprsntelnno: '82',
            // orderprsntelfno: apiData.appRecDTO.telnum,
            // orderprsntelmno: apiData.appRecDTO.telnum,
            // orderprsntellno: apiData.appRecDTO.telnum,
            orderprsntelno: '010-3338-9354', //전체
            orderprsnhtelfno: '10',
            orderprsnhtelmno: '3338',
            orderprsnhtellno: '9354', //전체
            orderprsnhtelno: '010-3338-9354',
            orderprsnemailid: 'help@btorage.com',

            // EM_gubun: apiData.customsDTO.customItemDTO.hsCodeNm, //상품구분
            EM_gubun: "Gift", //상품구분 동적으로 맵핑해야함
            contents: apiData.customsDTO.custContent, //내용품명
            number: apiData.customsDTO.custQty, //개수
            weight: Math.round(apiData.shipInfoDTO.weight * 1000), //순중량
            value: apiData.customsDTO.custPrice, //가격
            hs_code: apiData.customsDTO?.customItemDTO?.hsCode || '', //hscode
            origin: 'KR', //생산지
            // modelno: apiData.customsDTO.custContent, // 규격

            // ecommerceyn: 'Y',
            // exportsendprsnnm: 'IM EUN WOO',
            // exportsendprsnaddr: '42beon-gill, 1floor, Gonjiam-eup 32-15',
            // bizregno: '8616100177',
            // xprtnoyn: 'N',
            // xprtno1: '',
            // xprtno2: '',
            // xprtno3: '',
            // xprtno4: '',
            // totdivsendyn1: 'N',
            // totdivsendyn2: 'N',
            // totdivsendyn3: 'N',
            // totdivsendyn4: 'N',
            // wrapcnt1: '',
            // wrapcnt2: '',
            // wrapcnt3: '',
            // wrapcnt4: '',
            //
            // skustockmgmtno: '',
            // paytypecd: '',
            // currunit: '',
            // paypprno: '',
            // dutypayprsncd: '',
            // dutypayamt: '',
            // dutypaycurr: '',
            boxlength: apiData.shipInfoDTO.wid,
            boxwidth: apiData.shipInfoDTO.ver,
            boxheight: apiData.shipInfoDTO.hei,
            currunitcd: 'USD',
            paySeqNum: apiData.seqNum, // payinfo 출고처리를 위한 필드(백엔드에서 삭제하고 시작)
        };
    });

    const [emsErrorList, setEmsErrorList] = useState([]);
    const emsConnectApi = async () => {
        if (isLoading) return;

        setIsLoading(true);
        setEmsErrorList([]); // 변경점 2: API 호출 전 오류 리스트 초기화

        try {
            const response = await axios({
                method: 'post',
                url: '/externalApi/emsReceipt',
                data: regData,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: LCAT
                }
            });

            // 백엔드에서 받은 리스트를 순회하며 성공/실패 처리
            const results = response.data;
            let errorList = [];

            for (const result of results) {
                if (result.error) {
                    // 실패 항목을 errorList에 추가
                    errorList.push({
                        seqNum: result.paySeqNum,
                        code: result.errorCode,
                        message: result.errorMessage
                    });
                } else {
                    // 성공 항목 처리 (기존 .then() 로직)
                    const payinfo = result.data; // 실제 데이터는 'data' 필드에 있음
                    await sendMessage(payinfo);
                    await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: payinfo.orderdtDTO.memberDTO.mbNum}));
                }
            }

            // 변경점 4: 집계된 오류 리스트를 state에 저장
            if (errorList.length > 0) {
                setEmsErrorList(errorList);
                window.scrollTo({top: 0, behavior: 'smooth'}); // 오류 발생 시 화면 상단으로 이동
            } else {
                // 접수 성공 시에만 새로고침
                ordReceiptSelect();
            }

        } catch (error) {
            console.error('EMS API 요청 실패:', error.response || error);
            setEmsErrorList([
                {
                    seqNum: '전체',
                    code: 'NETWORK_ERROR',
                    message: '서버와 통신하는 중 오류가 발생했습니다.'
                }
            ]);
            window.scrollTo({top: 0, behavior: 'smooth'});

        } finally {
            setIsLoading(false);
            setAlertShowEms(false);
        }
    }


    const getMessage = (lang, userName, shipco) => {
        switch (lang) {
            case "Korean":
                return `안녕하세요 ${userName}님^^*\n주문해주신 상품이 ${shipco === "국내배송" ? "국내" : "해외"}로 출발하였습니다.\n무사히 수령하실 때까지 도움드릴 일 있으시면 언제든지 문의주세요 :)\n\n저희 Btorage를 믿고 이용해주셔서 진심으로 감사드립니다 !`;
            case "Chinese":
                return `您好，${userName}^^*\n您订购的商品已${shipco === "국내배송" ? "在国内" : "在国际"}发出。\n在您安全收到商品前，如需任何帮助，请随时联系我们 :)\n\n感谢您信任并使用Btorage！`;
            case "Japanese":
                return `こんにちは、${userName}さん^^*\nご注文いただいた商品が${shipco === "국내배송" ? "国内" : "海外"}に発送されました。\n無事にお受け取りいただけるまで、何かお手伝いが必要な際はいつでもご連絡ください :)\n\nBtorageをご利用いただき、本当にありがとうございます！`;
            case "Indonesian":
                return `Halo ${userName}^^*\nBarang pesanan Anda telah dikirim ${shipco === "국내배송" ? "di dalam negeri" : "ke luar negeri"}.\nJika Anda membutuhkan bantuan sampai barang diterima dengan aman, jangan ragu untuk menghubungi kami kapan saja :)\n\nTerima kasih telah mempercayai dan menggunakan Btorage!`;
            default:
                return `Hello ${userName}^^*\nYour ordered items have been shipped ${shipco === "국내배송" ? "domestically" : "internationally"}.\nIf you need any assistance until you safely receive them, please feel free to contact us anytime :)\n\nThank you sincerely for trusting and using Btorage!`;
        }
    };

    // <a href="${myPgLink}">마이페이지 바로가기</a>
    const getHtmlMessage = (lang, userName, shipco) => {
        switch (lang) {
            case "Korean":
                return `안녕하세요 ${userName}님^^*<br>주문해주신 상품이 ${shipco === "국내배송" ? "국내" : "해외"}로 출발하였습니다.<br>무사히 수령하실 때까지 도움드릴 일 있으시면 언제든지 문의주세요 :)<br><br>저희 비토리지를 믿고 이용해주셔서 진심으로 감사드립니다 !`;

            case "Chinese":
                return `您好，${userName}^^*<br>您订购的商品已${shipco === "국내배송" ? "在国内" : "在国际"}发出。<br>在您安全收到商品前，如需任何帮助，请随时联系我们 :)<br><br>感谢您信任并使用Btorage！`;
            case "Japanese":
                return `こんにちは、${userName}さん^^*<br>ご注文いただいた商品が${shipco === "국내배송" ? "国内" : "海外"}に発送されました。<br>無事にお受け取りいただけるまで、何かお手伝いが必要な際はいつでもご連絡ください :)<br><br>Btorageをご利用いただき、本当にありがとうございます！`;
            case "Indonesian":
                return `Halo ${userName}^^*<br>Barang pesanan Anda telah dikirim ${shipco === "국내배송" ? "di dalam negeri" : "ke luar negeri"}.<br>Jika Anda membutuhkan bantuan sampai barang diterima dengan aman, jangan ragu untuk menghubungi kami kapan saja :)<br><br>Terima kasih telah mempercayai dan menggunakan Btorage!`;
            default:
                return `Hello ${userName}^^*<br>Your ordered items have been shipped ${shipco === "국내배송" ? "domestically" : "internationally"}.<br>If you need any assistance until you safely receive them, please feel free to contact us anytime :)<br><br>Thank you sincerely for trusting and using Btorage!`;
        }
    };

    // const sendMessage = async (data) => {
    //     const memberDTO = data?.orderdtDTO?.memberDTO;
    //     const userName = memberDTO.userName;
    //     const lang = memberDTO.lang;
    //     const shipco = data?.orderdtDTO.shipco;
    //     const chatSendLang = getMessage(lang, userName, shipco);
    //     const emailSendLang = getHtmlMessage(lang, userName, shipco);
    //
    //     if (stompClient && stompClient.connected && chatSendLang.trim() !== '' && emailSendLang.trim() !== '') {
    //         const chatMessage = {
    //             chatKey: chatSendLang,
    //             fileNm: null,
    //             chatOrdNum: Number(data?.orderdtDTO.orderNumber),
    //             mbNum: adminInfo.mbNum,
    //             memberDTO: memberDTO,
    //             mstMbNum: memberDTO.mbNum,
    //             mstUserNm: userName,
    //             email: memberDTO.id,
    //             sendMailFl: true,
    //             autoChatFl: true,
    //             lang: lang,
    //             process: "PS3",
    //             emailKey: emailSendLang
    //         };
    //         await stompClient.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));
    //     } else {
    //         console.log("메시지 전송실패");
    //     }
    // }

    const sendMessage = async (data) => {
        const memberDTO = data?.orderdtDTO?.memberDTO;
        const userName = memberDTO.userName;
        const lang = memberDTO.lang;
        const shipco = data?.orderdtDTO.shipco;
        const chatSendLang = getMessage(lang, userName, shipco);
        const emailSendLang = getHtmlMessage(lang, userName, shipco);

        if (stompClient && stompClient.connected && chatSendLang.trim() !== '' && emailSendLang.trim() !== '') {
            return await executeSend(stompClient, memberDTO, userName, lang, shipco, chatSendLang, emailSendLang, data);
        } else {
            console.log("웹소켓 끊김 감지, 재연결 시도 중...");
            try {
                const activeClient = await websocketConnect(adminInfo.mbNum);
                if (activeClient && activeClient.connected && chatSendLang.trim() !== '' && emailSendLang.trim() !== '') {
                    return await executeSend(activeClient, memberDTO, userName, lang, shipco, chatSendLang, emailSendLang, data);
                }
            } catch (error) {
                console.error("재연결 실패:", error);
            }
            console.log("메시지 전송실패");
            return false;
        }
    };

    const executeSend = async (client, memberDTO, userName, lang, shipco, chatSendLang, emailSendLang, data) => {
        const chatMessage = {
            chatKey: chatSendLang,
            fileNm: null,
            chatOrdNum: Number(data?.orderdtDTO.orderNumber),
            mbNum: adminInfo.mbNum,
            memberDTO: memberDTO,
            mstMbNum: memberDTO.mbNum,
            mstUserNm: userName,
            email: memberDTO.id,
            sendMailFl: true,
            autoChatFl: true,
            lang: lang,
            process: "PS3",
            emailKey: emailSendLang
        };
        await client.send("/app/chat/adminMessage", {}, JSON.stringify(chatMessage));
        return true;
    };

    // region Excel

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;

    // FedEx Excel
    const excelDownFedex = () => {
        try {
            //미국, 캐나다 의경우 우편번호에 따라 주(state)코드 엑셀에 보이게
            const excelType = 'FedEx';
            const allowedTypes = ['D01', 'D16'];

            const selectedRows = ordReceiptData
                .filter(item => checked.includes(item.seqNum))
                .filter(item => allowedTypes.includes(item.dvType));

            if (selectedRows.length === 0 || (selectedRows.dvType === "D01" || selectedRows.dvType === "D16")) {
                setNonFedexDataSt(true);
                return null;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            const transformedSelectedRows = selectedRows.map(mapDataToExcelRowFEDEX);


            function mapDataToExcelRowFEDEX(item) {
                const recDvType = item.dvType;
                const serviceType = recDvType === 'D01' ? '2P' : 'EC';

                let packingType;
                const fedexPack = item.shipInfoDTO.fedexPack;
                if (fedexPack === '1') {
                    packingType = '2';
                } else {
                    packingType = '1';
                }

                let address1 = item.appRecDTO.address1.substring(0, 35);
                let address2 = item.appRecDTO.address2.substring(0, 35);
                let address3 = item.appRecDTO.address3.substring(0, 35);
                const city = item.appRecDTO.city.substring(0, 35);

                if (item.appRecDTO.address1.length > 35) {
                    const remainingChars = 35 - address1.length;
                    address1 = address1 + item.appRecDTO.address1.substring(35, 35 + remainingChars);
                }
                if (item.appRecDTO.address2.length > 35) {
                    const remainingChars = 35 - address2.length;
                    address2 = address2 + item.appRecDTO.address2.substring(35, 35 + remainingChars);
                }
                if (item.appRecDTO.address3.length > 35) {
                    const remainingChars = 35 - address3.length;
                    address3 = address3 + item.appRecDTO.address3.substring(35, 35 + remainingChars);
                }

                const cleanTel = item.appRecDTO.telnum?.replace(/[^\d]/g, '') || '';

                const isUS = item.appRecDTO.countryDTO.countryCode === 'US';
                const hscode = isUS ? '6505009090' : '650500';

                return {
                    '주문번호키': item.orderdtDTO?.orderNumber,
                    '주문번호': item.orderdtDTO?.orderNumber,
                    'TaxID': item.appRecDTO.taxid,
                    '수취인성함': item.appRecDTO.recname,
                    '수취인주소1': address1,
                    '수취인주소2': address2,
                    '상세주소': address3,
                    '도시명': city,
                    '국가코드': item.appRecDTO.countryDTO.countryCode,
                    '우편번호': item.appRecDTO.zipcode,
                    '연락처': cleanTel,
                    '이메일': item.orderdtDTO.memberDTO.id,
                    '내용품명': item.customsDTO.custContent,
                    'hscode': item.customsDTO?.customItemDTO?.hsCode || '',
                    '수량': item.customsDTO.custQty,
                    'KR': 'KR',
                    '금액': item.customsDTO.custPrice,
                    '무게1': item.shipInfoDTO.weight,
                    'PCS': 'PCS',
                    '1carton': '1',
                    '무게': item.shipInfoDTO.weight,
                    '길이': item.shipInfoDTO.ver,
                    '가로': item.shipInfoDTO.wid,
                    '세로': item.shipInfoDTO.hei,
                    '서비스종류': serviceType,
                    '포장재종류': packingType,
                    'Payment Type': 1,
                    'Payer Account Number': ''
                };
            }

            const specialHeaders = [
                'Transaction ID*'
                , 'Reference Notes / Order ID* (35)'
                , '수취인성함* (35)'
                , '수취인주소 1* (35)'
                , '수취인주소 2* (35)'
                , '도시명* (35)'
                , '국가코드* (2)'
                , '우편번호* (10)'
                , '전화번호* (15)'
                , '내용품명* (148)'
                , '수량* (7)'
                , '제조국가* (2)'
                , '전화번호* (15)'
                , '단가* (15)'
                , '단위* (3)'
                , '패키지수* (4)'
                , '택배무게* (13)'
                , '서비스종류*\n' +
                '1) IP\n' +
                '3) IE\n' +
                '6) Int\'l First\n' +
                '17) IED\n' +
                '18) IPD\n' +
                '70) IPF\n' +
                '84) IDF\n' +
                '86) IEF"'
                , '포장재*\n' +
                '01 - Other\n' +
                '02 - FedEx Pak\n' +
                '03 - FedEx Box\n' +
                '04 - FedEx Tube\n' +
                '06 - Envelope'
                , 'Payment Type\n' +
                '1)Shipper\n' +
                '2)Recipient\n' +
                '3)3rd Party'
                , 'Payer Account Number'
            ];

            const specialHeaderStyle = {
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'FFFF0000'}
                }
            };

            const sheetConfigs = {
                'DHL': {
                    name: 'DHL',
                    columns: ['DHL'],
                },
                'FedEx': {
                    name: 'FedEx',
                    columns: [
                        {header: 'Transaction ID*', key: '주문번호키', hidden: false, height: 15, width: 22},
                        {header: 'Reference Notes / Order ID* (35)', key: '주문번호', width: 22},
                        {header: 'Preassign Tracking Number', key: '', width: 0},
                        {header: 'Booking Number', key: '', width: 0},
                        {header: 'Recipient IRS/EIN Number', key: 'TaxID', width: 20},
                        {header: '수취인성함* (35)', key: '수취인성함', width: 20},
                        {header: 'Recipient Company Name (35)', key: '', width: 0},
                        {header: '수취인주소 1* (35)', key: '수취인주소1', width: 40},
                        {header: '수취인주소 2* (35)', key: '수취인주소2', width: 40},
                        {header: 'Recipient Address Line 3 (35) ) - v13', key: '상세주소', width: 40},
                        {header: '도시명* (35)', key: '도시명', width: 15},
                        {header: 'Shipping Contents / Product Code (20)', key: '', width: 0},
                        {header: '국가코드* (2)', key: '국가코드', width: 12},
                        {header: '우편번호* (10)', key: '우편번호', width: 12},
                        {header: '전화번호* (15)', key: '연락처', width: 16},
                        {header: 'Recipient Tel Ext. (6) - v13', key: '', width: 0},
                        {header: 'Recipient Email (60)', key: '이메일', width: 22},
                        {header: '내용품명* (148)', key: '내용품명', width: 25},
                        {header: 'HS CODE (20)', key: 'hscode', width: 13},
                        {header: '수량* (7)', key: '수량', width: 12},
                        {header: '제조국가* (2)', key: 'KR', width: 12},
                        {header: '단가* (15)', key: '금액', width: 10},
                        {header: 'Commodity Unit Weight (16)', key: '무게1', width: 12},
                        {header: 'Invoice Number (20)', key: '', width: 0},
                        {header: 'CI Comments (300)', key: '', width: 0},
                        {header: 'CI Freight Charge (11)', key: '', width: 0},
                        {header: '단위* (3)', key: 'PCS', width: 9},
                        {header: '패키지수* (4)', key: '1carton', width: 12},
                        {header: '택배무게* (13)', key: '무게', width: 12},
                        {header: 'length', key: '길이', width: 11},
                        {header: 'width', key: '가로', width: 11},
                        {header: 'height', key: '세로', width: 11},
                        {
                            header: '서비스종류*\n' +
                                '1) IP\n' +
                                '3) IE\n' +
                                '6) Int\'l First\n' +
                                '17) IED\n' +
                                '18) IPD\n' +
                                '70) IPF\n' +
                                '84) IDF\n' +
                                '86) IEF', key: '서비스종류', width: 18
                        },
                        {
                            header: '포장재*\n' +
                                '01 - Other\n' +
                                '02 - FedEx Pak\n' +
                                '03 - FedEx Box\n' +
                                '04 - FedEx Tube\n' +
                                '06 - Envelope', key: '포장재종류', width: 18
                        },
                        {
                            header: 'Payment Type\n' +
                                '1)Shipper\n' +
                                '2)Recipient\n' +
                                '3)3rd Party', key: 'Payment Type', width: 17
                        },
                        {header: 'Payer Account Number', key: 'Payer Account Number', width: 25}
                    ],
                }
            };

            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };
            const borderBodyStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({includeEmpty: true}, (cell) => {
                    cell.border = border;
                });
            };

            const applyStylesToHeader = (sheet, height) => {
                const headerRow = sheet.getRow(1);
                headerRow.font = {name: '맑은 고딕', bold: true, size: 10};
                headerRow.alignment = {horizontal: 'center', vertical: 'middle', wrapText: true};
                headerRow.height = height;


                headerRow.eachCell((cell, number) => {
                    if (specialHeaders.includes(sheet.columns[number - 1].header)) {
                        cell.style = {...cell.style, ...specialHeaderStyle};
                    }
                });
                applyBordersToRow(headerRow, borderHeaderStyle);
            };

            const createSheet = (name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                applyStylesToHeader(sheet, 80);
                return sheet;
            };

            const addRowsToSheet = (sheet, rows, border) => {
                rows.forEach((item, index) => {
                    const row = sheet.addRow(item);
                    for (let i = 1; i <= sheet.columns.length; i++) {
                        row.getCell(i).font = {name: '맑은 고딕', size: 10};
                    }
                    applyBordersToRow(row, border);
                });
            };

            if (sheetConfigs[excelType]) {
                const sheet = createSheet(sheetConfigs[excelType].name, sheetConfigs[excelType].columns);
                applyStylesToHeader(sheet, 80, excelType);
                addRowsToSheet(sheet, transformedSelectedRows, borderBodyStyle);
            }

            const payInfo = selectedRows[0];
            const name = payInfo.appRecDTO.recname;
            const shipco = convertToShipco(payInfo.dvType);
            const trackNum = payInfo.shipInfoDTO.outWayNum;

            let fileName = `${shipco}_${trackNum}_${name}_Invoice.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.error(error);
        } finally {
            setChecked([]);
            setShipcoChecked([]);
        }
    };


    // EMS Excel
    const excelDownEms = () => {
        try {
            const excelType = 'EMS';
            const allowedTypes = ['D02', 'D15'];

            const selectedRows = ordReceiptData
                .filter(item => checked.includes(item.seqNum))
                .filter(item => allowedTypes.includes(item.dvType));

            if (selectedRows.length === 0 || (selectedRows.dvType === "D02" || selectedRows.dvType === "D15")) {
                setNonEmsDataSt(true);
                return null;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            function mapDataToExcelRowEMS(item) {

                console.log("EMS 아이템 : ", item);

                const maxLengthAddress1 = 200;

                let address1 = item.appRecDTO.address1.substring(0, maxLengthAddress1);

                let address2 = '';
                let address3 = '';

                if (item.appRecDTO.address1.length > maxLengthAddress1) {
                    const remainingChars = item.appRecDTO.address1.length - maxLengthAddress1;
                    address2 = item.appRecDTO.address1.substring(maxLengthAddress1, maxLengthAddress1 + remainingChars);
                    address1 = address1.substring(0, maxLengthAddress1);
                }

                // let address1 = item.appRecDTO.address1.substring(0, 200);
                // let address2 = item.appRecDTO.address2.substring(0, 50);
                // let address3 = item.appRecDTO.address3.substring(0, 50);
                const city = item.appRecDTO.city.substring(0, 50);
                //
                // if (item.appRecDTO.address2.length > 50) {
                //     const remainingChars = 50 - address2.length;
                //     address3 = item.appRecDTO.address2.substring(50, 50 + remainingChars) + address3;
                //     address2 = address2 + item.appRecDTO.address2.substring(0, remainingChars);
                // }

                const dvTypeMap = {
                    D02: 'E',
                    D13: 'K',
                    D15: 'P'
                };
                const eType = dvTypeMap[item.dvType] || '';

                // 미국(US): 우체국은 '.' 없이 숫자 10자리만 허용 (예: 1234.12.1234 → 1234121234)
                let hsCode = item.customsDTO?.customItemDTO?.hsCode || '';
                if (item.appRecDTO.countryDTO.countryCode === 'US') {
                    hsCode = String(hsCode).replace(/[^0-9]/g, '').substring(0, 10);
                }

                return {
                    '상품구분': 'Gift',
                    '수취인명': item.appRecDTO.recname,
                    '수취인전화': item.appRecDTO.telnum,
                    '수취인국가코드': item.appRecDTO.countryDTO.countryCode,
                    '수취인우편번호': item.appRecDTO.zipcode,
                    '수취인상세주소': address1,
                    '수취인주소1': address2,
                    '수취인주소2': address3 + city,
                    '실중량1': Math.round(item.shipInfoDTO.weight * 1000),
                    '내용품명': item.customsDTO.custContent,
                    '개수': item.customsDTO.custQty,
                    '실중량2': Math.round(item.shipInfoDTO.weight * 1000),
                    '가격': item.customsDTO.custPrice,
                    '통화단위': 'USD',
                    'HSCODE': hsCode,
                    '생산지': 'KR',
                    'E': eType,
                    'em': 'em',
                    '가로': item.shipInfoDTO.ver,
                    '세로': item.shipInfoDTO.wid,
                    '높이': item.shipInfoDTO.hei,
                    // 유럽 PID 컬럼 (우체국 신규 양식 BP~BR, 현재 미구현으로 빈 값 업로드)
                    'MPID': '',
                    'NSPID': '',
                    'SPID': '',
                };
            }

            const specialHeaders = [
                '상품구분\n' +
                '(Sample-샘플)\n' +
                '(Gift-선물)\n' +
                '(Merchandise-상품)\n' +
                '(Document-서류)'
                , '수취인명\n' +
                '(35자이내 공백포함)'
                , '수취인국가코드'
                , '수취인우편번호\n' +
                '(숫자,문자 가능\n' +
                '17자이내)'
                , '수취인 상세주소\n' +
                '(200byte 이내)'
                , '수취인\n' +
                '시/군/구(예시) 주소\n' +
                '(50byte 이내)'
                , '수취인\n' +
                '주/도/시(예시) 주소\n' +
                '(50byte 이내)'
                , '박스포장\n' +
                '실 중량(g)'
                , '내용품명\n' +
                '(영문 32자이내 \n' +
                '공백포함)'
                , 'EMS : E\n' +
                'EMS 프리미엄 : P\n' +
                'K-Packet : K\n' +
                '등기소형 :R'
                , 'EMS 비서류 : em,    \n' +
                ' EMS 서류 : ee,\n' +
                ' K-Packet : rl, \n' +
                '소형포장물 : re'
                , '가로(cm)'
                , '세로(cm)'
                , '높이(cm)'
            ];

            const specialHeaderStyle = {
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'FFFF0000'}
                }
            };

            const sheetConfigs = {
                'EMS': {
                    name: 'EMS',
                    columns: [
                        {
                            header: '상품구분\n' +
                                '(Sample-샘플)\n' +
                                '(Gift-선물)\n' +
                                '(Merchandise-상품)\n' +
                                '(Document-서류)', key: '상품구분', hidden: false, width: 20
                        },
                        {
                            header: '수취인명\n' +
                                '(35자이내 공백포함)', key: '수취인명', width: 33
                        },
                        {header: '수취인EMAIL', key: '', width: 0},
                        {
                            header: '수취인전화\n' +
                                '국가번호\n' +
                                '(숫자4자리)', key: '', width: 0
                        },
                        {
                            header: '수취인전화\n' +
                                '지역번호\n' +
                                '(숫자4자리)', key: '', width: 0
                        },
                        {
                            header: '수취인전화\n' +
                                '국번\n' +
                                '(숫자4자리)', key: '', width: 0
                        },
                        {
                            header: '수취인전화\n' +
                                '전화번호\n' +
                                '(숫자4자리)', key: '', width: 0
                        },
                        {
                            header: '수취인전화\n' +
                                '(숫자, - 허용)', key: '수취인전화', width: 14
                        },
                        {header: '수취인국가코드', key: '수취인국가코드', width: 14},
                        {
                            header: '수취인국가명\n' +
                                '(영문국가명 국가코드 확실\n' +
                                '시  생략가능) ', key: '', width: 0
                        },
                        {
                            header: '수취인우편번호\n' +
                                '(숫자,문자 가능\n' +
                                '17자이내)', key: '수취인우편번호', width: 14
                        },
                        {
                            header: '수취인 상세주소\n' +
                                '(200byte 이내)', key: '수취인상세주소', width: 38
                        },
                        {
                            header: '수취인\n' +
                                '시/군/구(예시) 주소\n' +
                                '(50byte 이내)', key: '수취인주소1', width: 35
                        },
                        {
                            header: '수취인\n' +
                                '주/도/시(예시) 주소\n' +
                                '(50byte 이내)', key: '수취인주소2', width: 35
                        },
                        {
                            header: '수취인 건물명\n' +
                                '미국행 K-Packet 이용할 경우만 \n' +
                                '입력가능\n' +
                                '( 영문 공백포함 90자 이내 )', key: '', width: 0
                        },
                        {
                            header: '박스포장\n' +
                                '실 중량(g)', key: '실중량1', width: 11
                        },
                        {
                            header: '내용품명\n' +
                                '(영문 32자이내 \n' +
                                '공백포함)', key: '내용품명', width: 18
                        },
                        {header: '개수', key: '개수', width: 8},
                        {header: '순중량(g)', key: '실중량2', width: 11},
                        {header: '가격', key: '가격', width: 8},
                        {header: '통화단위', key: '통화단위', width: 10},
                        {
                            header: 'HSCODE\n' +
                                '(숫자만 10자리)', key: 'HSCODE', width: 15
                        },
                        {header: '생산지', key: '생산지', width: 8},
                        {header: '규격', key: '우편번호', width: 0},
                        {
                            header: '보험가입여부\n' +
                                '(Y/N)', key: '우편번호', width: 12
                        },
                        {
                            header: '보험가입금액\n' +
                                '(물품가액을\n' +
                                ' 기입 원\\)', key: '우편번호', width: 12
                        },
                        {
                            header: 'EMS : E\n' +
                                'EMS 프리미엄 : P\n' +
                                'K-Packet : K\n' +
                                '등기소형 :R', key: 'E', width: 15
                        },
                        {
                            header: 'EMS 비서류 : em,    \n' +
                                ' EMS 서류 : ee,\n' +
                                ' K-Packet : rl, \n' +
                                '소형포장물 : re', key: 'em', width: 15
                        },
                        {header: '1', key: '', width: 0},
                        {header: '2', key: '', width: 0},
                        {header: '3', key: '', width: 0},
                        {header: '4', key: '', width: 0},
                        {header: '5', key: '', width: 0},
                        {header: '6', key: '', width: 0},
                        {header: '7', key: '', width: 0},
                        {header: '8', key: '', width: 0},
                        {header: '9', key: '', width: 0},
                        {header: '10', key: '', width: 0},
                        {header: '11', key: '', width: 0},
                        {header: '12', key: '', width: 0},
                        {header: '13', key: '', width: 0},
                        {header: '14', key: '', width: 0},
                        {header: '15', key: '', width: 0},
                        {header: '16', key: '', width: 0},
                        {header: '17', key: '', width: 0},
                        {header: '18', key: '', width: 0},
                        {header: '19', key: '', width: 0},
                        {header: '20', key: '', width: 0},
                        {header: '21', key: '', width: 0},
                        {header: '22', key: '', width: 0},
                        {header: '23', key: '', width: 0},
                        {header: '24', key: '', width: 0},
                        {header: '25', key: '', width: 0},
                        {header: '26', key: '', width: 0},
                        {header: '27', key: '', width: 0},
                        {header: '28', key: '', width: 0},
                        {header: '29', key: '', width: 0},
                        {header: '30', key: '', width: 0},
                        {header: '31', key: '', width: 0},
                        {header: '32', key: '', width: 0},
                        {header: '33', key: '', width: 0},
                        {header: '34', key: '', width: 0},
                        {header: '가로(cm)', key: '가로', width: 10},
                        {header: '세로(cm)', key: '세로', width: 10},
                        {header: '높이(cm)', key: '높이', width: 10},
                        // BN~BO: 우체국 신규 양식 컬럼 (데이터 미사용, 양식 맞춤용)
                        {header: '부피중량 적용 제외 여부\n(Y/N)', key: '', width: 0},
                        {header: 'IOSS/EORI/\nTAX NUMBER\n식별 번호', key: '', width: 0},
                        // BP~BR: 유럽 PID (우체국 신규 양식, 미구현으로 빈 값)
                        {header: 'MPID\n(70Byte)', key: 'MPID', width: 15},
                        {header: 'NSPID\n(70Byte)', key: 'NSPID', width: 15},
                        {header: 'SPID\n(70Byte)', key: 'SPID', width: 15},
                    ],
                }
            };

            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({includeEmpty: true}, (cell) => {
                    cell.border = border;
                });
            };

            const applyStylesToHeader = (sheet, height) => {
                for (let i = 2; i <= 5; i++) {
                    const invisibleRow = sheet.getRow(i);
                    invisibleRow.height = 0.5;
                }

                const headerRow = sheet.getRow(1);
                headerRow.font = {name: '맑은 고딕', bold: true, size: 10};
                headerRow.alignment = {horizontal: 'center', vertical: 'middle', wrapText: true};
                headerRow.height = height;

                headerRow.eachCell((cell, number) => {
                    if (specialHeaders.includes(sheet.columns[number - 1].header)) {
                        cell.style = {...cell.style, ...specialHeaderStyle};
                    }
                });
                applyBordersToRow(headerRow, borderHeaderStyle);
            };

            const createSheet = (name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                applyStylesToHeader(sheet, 80);
                return sheet;
            };

            const addRowsToSheet = (sheet, rows, border) => {
                rows.forEach((item, index) => {
                    const row = sheet.addRow(item);
                    for (let i = 1; i <= sheet.columns.length; i++) {
                        row.getCell(i).font = {name: '맑은 고딕', size: 10};
                    }
                    applyBordersToRow(row, border);
                });
            };

            let transformedSelectedRows;
            transformedSelectedRows = selectedRows.map(mapDataToExcelRowEMS);

            if (sheetConfigs) {
                const sheet = createSheet(sheetConfigs['EMS'].name, sheetConfigs['EMS'].columns);
                applyStylesToHeader(sheet, 80);
                addRowsToSheet(sheet, transformedSelectedRows, borderHeaderStyle);
            }

            const payInfo = selectedRows[0];
            const name = payInfo.appRecDTO.recname;
            const shipco = convertToShipco(payInfo.dvType);
            const orderNum = payInfo.orderdtDTO.orderNumber;

            let fileName = `${shipco}_${orderNum}_${name}_Invoice.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.error(error);
        } finally {
            setChecked([]);
            setShipcoChecked([]);
        }
    };

    // S-Packet Excel
    const excelDownSPack = () => {
        try {
            const excelType = 'SPack';
            const allowedTypes = ['D14']; // 항공소형포장물 타입 코드

            const selectedRows = ordReceiptData
                .filter(item => checked.includes(item.seqNum))
                .filter(item => allowedTypes.includes(item.dvType));

            if (selectedRows.length === 0) {
                setNonSPackDataSt(true); // 알림 상태 설정
                return null;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            // 항공소형포장물 양식에 맞게 데이터 매핑
            function mapDataToExcelRowSPack(item) {
                console.log("S-Packet 아이템 : ", item);

                const customs = item.customsDTO;
                const weightInGrams = Math.round(item.shipInfoDTO.weight * 1000);
                const order = item.orderdtDTO;

                const useType = (order.useType === "U0" || order.useType === "U1") ? "Gift" : "Sample";
                const detailAddress = item.appRecDTO.address1 + item.appRecDTO.address2 + item.appRecDTO.address3
                const phoneParts = splitPhoneNumber(item.appRecDTO.telnum);

                return {
                    '받는 분 이름': item.appRecDTO.recname?.substring(0, 35) || '',
                    '국가': item.appRecDTO.countryDTO.countryCode || '',
                    '우편번호': item.appRecDTO.zipcode || '',
                    '받는 분 주소(Detail)': detailAddress?.substring(0, 200) || '',
                    '받는 분 주소(City)': item.appRecDTO.city?.substring(0, 50) || '',
                    '받는 분 주소(State)': 'input', // 'state' 필드 가정
                    '국가번호': phoneParts.g,
                    '지역번호': phoneParts.h,
                    '전화번호1': phoneParts.i,
                    '전화번호2': phoneParts.j,
                    'E-mail': item.orderdtDTO.memberDTO.id?.substring(0, 40) || '', // fetchFedexData 참고
                    '세금식별번호': item.appRecDTO.taxNum || '', // 'taxNum' 필드 가정
                    '부가세 식별번호': item.appRecDTO.vatNum || '', // 'vatNum' 필드 가정
                    '보험취급': customs.insrFl ? customs.insrPrice : '', // fetchFedexData 참고 ('insrFl', 'insrPrice' 필드 가정)
                    '상품견본': useType === 'Sample' ? 'O' : '',
                    '선물': useType === 'Gift' ? 'O' : '',
                    '상품': useType === 'Merchandise' ? 'O' : '',
                    '내용품명': customs.custContent?.substring(0, 75) || '',
                    '상품분류번호': customs?.customItemDTO?.hsCode || '',
                    '개수': customs.custQty || 0,
                    '총 금액': customs.custPrice || 0,
                    '통화코드': 'USD',
                    '순중량(g)': weightInGrams,
                    '생산지': 'KR',
                    '참고사항': ''
                };
            }

            // --- 템플릿 헤더 데이터 정의 ---
            const row1_Merges_SPack = ['A1:M1', 'N1:N1', 'O1:X1', 'Y1:Y1'];
            const row1_Values_SPack = {A: '받는분', N: '특수취급', O: '세관신고서', Y: ''};
            const row2_Values_SPack = [
                '받는 분 이름(Name)', '국가(Country)', '우편번호(ZipCode)', '받는 분 주소(Detail)', '받는 분 주소(City)', '받는 분 주소(State)', '연락처(Mobile No.) 국가번호', '연락처(Mobile No.) 지역번호', '연락처(Mobile No.) 전화번호1', '연락처(Mobile No.) 전화번호2', 'E-mail(필수사항)', '세금식별번호(필수사항)', '부가세 식별번호 (선택사항)', '보험취급', '상품견본(Sample)', '선물(Gift)', '상품(Merchandise)', '내용품명(Detailed description of contents)', '상품분류번호(HS Tariff Number)', '개수(Quantity)', '총 금액 (Total Value)', '통화코드(Currency Code)', '순중량(g) (Net weigth)', '생산지(Country of Origin)', '참고사항'
            ];
            const row3_Values_SPack = [
                '영문,공백 최대35글자', '국가코드를 영문 2글자로 입력해주세요', '배달보장서비스국가는 필수입력', '영문,숫자,공백 200글자', '영문,숫자,공백 최대50글자', '영문,숫자,공백 최대50글자', '숫자 최대4글자', '숫자 최대4글자', '숫자 최대4글자', '숫자 최대4글자', '최대40글자', '받는분 국가가 브라질인 경우에만 입력\n수령인 일반개인(자연인) : CPF 번호,\n수령인 법인 : CNPJ번호 입력', '받는분 국가가 \n유럽 27개국 : IOSS 또는 TAX NUMBER 입력, \n영국 : EORI 또는 TAX NUMBER 입력,\n인도네시아 : NPWP 또는 TAX NUMBER 입력,\n그 외 국가 : TAX NUMBER 입력', '최대 금액 \n7,000,000 까지 입력가능', '상품견본, 선물, 상품 중에 1곳에만 "O"표 해주세요\n세관신고서 등록 시, 받는 분이 동일할 때, 4건까지 등록가능합니다.', '', '', '필수입력 영어,숫자,공백 75글자까지 입력 가능', '6~10자리 숫자까지 입력 가능', '7자리 숫자\n( 9999999 까지 입력 가능 )', '필수입력\nUSD, EUR, GBP, CNY: 4자리.2자리 숫자( 9999.99 까지 입력 가능 )\nJPY, KRW: 6자리 숫자\n( 999999 까지 입력 가능 )', '필수입력\n(USD, EUR, GBP, JPY, CNY, KRW 입력가능)\n* 내용품이 여러개인 경우 \n가격의 통화코드는 동일해야 합니다.', '10자리 숫자\n( 9999999999 까지 입력 가능 )', '생산지에 해당하는 국가의 국가코드를 2글자 영문으로 입력해주세요', '작성 하실 때 참고하세요'
            ];
            // --- 템플릿 헤더 데이터 정의 끝 ---

            // ✅ [수정] specialHeaders_SPack 정의 (원본 코드에서 복사)
            const specialHeaders_SPack = [
                '받는 분 이름(Name)\n' +
                '영문,공백 최대35글자',
                '국가(Country)\n' +
                '국가코드를 영문 2글자로 입력해주세요',
                '우편번호(ZipCode)\n' +
                '배달보장서비스국가는 필수입력',
                '받는 분 주소(Detail)\n' +
                '영문,숫자,공백 200글자',
                '받는 분 주소(City)\n' +
                '영문,숫자,공백 최대50글자',
                '받는 분 주소(State)\n' +
                '영문,숫자,공백 최대50글자',
                '연락처(Mobile No.) 국가번호\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 지역번호\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 전화번호1\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 전화번호2\n' +
                '숫자 최대4글자',
                'E-mail(필수사항)\n' +
                '최대40글자',
                '세금식별번호(필수사항)\n' +
                '받는분 국가가 브라질인 경우에만 입력\n' +
                '수령인 일반개인(자연인) : CPF 번호,\n' +
                '수령인 법인 : CNPJ번호 입력',
                '부가세 식별번호 (선택사항)\n' +
                '받는분 국가가 \n' +
                '유럽 27개국 : IOSS 또는 TAX NUMBER 입력, \n' +
                '영국 : EORI 또는 TAX NUMBER 입력,\n' +
                '인도네시아 : NPWP 또는 TAX NUMBER 입력,\n' +
                '그 외 국가 : TAX NUMBER 입력',
                '보험취급\n' +
                '최대 금액 \n' +
                '7,000,000 까지 입력가능',
                '상품견본(Sample)\n' +
                '상품견본, 선물, 상품 중에 1곳에만 "O"표 해주세요\n' +
                '세관신고서 등록 시, 받는 분이 동일할 때, 4건까지 등록가능합니다.',
                '선물(Gift)',
                '상품(Merchandise)',
                '내용품명(Detailed description of contents)\n' +
                '필수입력 영어,숫자,공백 75글자까지 입력 가능',
                '상품분류번호(HS Tariff Number)\n' +
                '6~10자리 숫자까지 입력 가능',
                '개수(Quantity)\n' +
                '7자리 숫자\n' +
                '( 9999999 까지 입력 가능 )',
                '총 금액 (Total Value)\n' +
                '필수입력\n' +
                'USD, EUR, GBP, CNY: 4자리.2자리 숫자( 9999.99 까지 입력 가능 )\n' +
                'JPY, KRW: 6자리 숫자\n' +
                '( 999999 까지 입력 가능 )',
                '통화코드(Currency Code)\n' +
                '필수입력\n' +
                '(USD, EUR, GBP, JPY, CNY, KRW 입력가능)\n' +
                '* 내용품이 여러개인 경우 \n' +
                '가격의 통화코드는 동일해야 합니다.',
                '순중량(g) (Net weigth)\n' +
                '10자리 숫자\n' +
                '( 9999999999 까지 입력 가능 )',
                '생산지(Country of Origin)\n' +
                '생산지에 해당하는 국가의 국가코드를 2글자 영문으로 입력해주세요',
                '참고사항\n' +
                '작성 하실 때 참고하세요'
            ];

            // ✅ [수정] specialHeaderStyle 정의 (원본 코드에서 복사)
            const specialHeaderStyle = {
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'FFFF0000'} // 빨간색
                }
            };

            // ✅ [수정] sheetConfigs 정의 (원본 코드에서 복사)
            const sheetConfigs = {
                'SPack': {
                    name: '항공소형포장물', // 시트 이름
                    columns: [
                        // A-M: 받는분
                        {header: specialHeaders_SPack[0], key: '받는 분 이름', width: 30},
                        {header: specialHeaders_SPack[1], key: '국가', width: 15},
                        {header: specialHeaders_SPack[2], key: '우편번호', width: 20},
                        {header: specialHeaders_SPack[3], key: '받는 분 주소(Detail)', width: 40},
                        {header: specialHeaders_SPack[4], key: '받는 분 주소(City)', width: 25},
                        {header: specialHeaders_SPack[5], key: '받는 분 주소(State)', width: 25},
                        {header: specialHeaders_SPack[6], key: '국가번호', width: 15},
                        {header: specialHeaders_SPack[7], key: '지역번호', width: 15},
                        {header: specialHeaders_SPack[8], key: '전화번호1', width: 15},
                        {header: specialHeaders_SPack[9], key: '전화번호2', width: 15},
                        {header: specialHeaders_SPack[10], key: 'E-mail', width: 30},
                        {header: specialHeaders_SPack[11], key: '세금식별번호', width: 30},
                        {header: specialHeaders_SPack[12], key: '부가세 식별번호', width: 30},
                        // N: 특수취급
                        {header: specialHeaders_SPack[13], key: '보험취급', width: 20},
                        // O-X: 세관신고서
                        {header: specialHeaders_SPack[14], key: '상품견본', width: 25},
                        {header: specialHeaders_SPack[15], key: '선물', width: 10},
                        {header: specialHeaders_SPack[16], key: '상품', width: 10},
                        {header: specialHeaders_SPack[17], key: '내용품명', width: 30},
                        {header: specialHeaders_SPack[18], key: '상품분류번호', width: 20},
                        {header: specialHeaders_SPack[19], key: '개수', width: 15},
                        {header: specialHeaders_SPack[20], key: '총 금액', width: 25},
                        {header: specialHeaders_SPack[21], key: '통화코드', width: 25},
                        {header: specialHeaders_SPack[22], key: '순중량(g)', width: 20},
                        {header: specialHeaders_SPack[23], key: '생산지', width: 25},
                        // Y: 참고사항
                        {header: specialHeaders_SPack[24], key: '참고사항', width: 30}
                    ],
                }
            };

            // ✅ [수정] borderHeaderStyle 정의 (원본 코드에서 복사)
            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            // --- 스타일 및 폰트 정의 ---
            const alignmentCenter = {horizontal: 'center', vertical: 'middle', wrapText: true};
            const fontBold = {name: '맑은 고딕', bold: true, size: 10};
            const fontNormal = {name: '맑은 고딕', size: 10};

            // 데이터 변환
            let transformedSelectedRows = selectedRows.map(mapDataToExcelRowSPack);

            // 시트 생성 및 설정
            if (sheetConfigs) {
                // ✅ [수정] config가 undefined인지 확인
                const config = sheetConfigs['SPack'];
                if (!config) {
                    console.error("SPack sheet configuration not found.");
                    return;
                }

                const sheet = workbook.addWorksheet(config.name); // 오류 발생 지점
                const columnsConfig = config.columns;

                // 1. 컬럼 설정 (키, 너비 매핑용)
                sheet.columns = columnsConfig;

                // 2. 1행 (병합 타이틀) 생성
                row1_Merges_SPack.forEach(merge => sheet.mergeCells(merge));
                const row1 = sheet.getRow(1);
                row1.height = 20;
                Object.keys(row1_Values_SPack).forEach(cellKey => {
                    sheet.getCell(cellKey + '1').value = row1_Values_SPack[cellKey];
                });
                row1.eachCell({includeEmpty: true}, cell => {
                    cell.font = fontBold;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                });

                // 3. 2행 (헤더명) 생성
                const row2 = sheet.getRow(2);
                row2.values = row2_Values_SPack;
                row2.height = 60;
                row2.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = fontBold;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                    // 빨간 배경 적용
                    const colConfigHeader = columnsConfig[colNumber - 1]?.header;
                    if (specialHeaders_SPack.includes(colConfigHeader)) {
                        cell.fill = specialHeaderStyle.fill;
                    }
                });

                // 4. 3행 (제한조건) 생성
                const row3 = sheet.getRow(3);
                row3.values = row3_Values_SPack;
                row3.height = 120; // 텍스트 줄바꿈을 위해 충분한 높이
                row3.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = fontNormal;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                    // 빨간 배경 적용
                    const colConfigHeader = columnsConfig[colNumber - 1]?.header;
                    if (specialHeaders_SPack.includes(colConfigHeader)) {
                        cell.fill = specialHeaderStyle.fill;
                    }
                });

                // 5. 4행부터 데이터 추가 (가운데 정렬 포함)
                transformedSelectedRows.forEach((item, index) => {
                    const row = sheet.addRow(item); // 4행부터 데이터 시작
                    row.eachCell({includeEmpty: true}, (cell) => {
                        cell.font = fontNormal;
                        cell.border = borderHeaderStyle;
                        cell.alignment = alignmentCenter; // 문제 3 해결: 데이터 셀 가운데 정렬
                    });
                });
            }

            // 파일명 생성 및 다운로드
            const payInfo = selectedRows[0];
            const name = payInfo.appRecDTO.recname;
            const shipco = convertToShipco(payInfo.dvType);
            const orderNum = payInfo.orderdtDTO.orderNumber;

            let fileName = `${shipco}_${orderNum}_${name}_Invoice.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.error("S-Packet 엑셀 다운로드 중 오류 발생:", error);
        } finally {
            setChecked([]);
            setShipcoChecked([]);
        }
    };

    // Sea Excel
    const excelDownSea = () => {
        try {
            const excelType = 'Sea';
            const allowedTypes = ['D03']; // 선편 타입 코드

            const selectedRows = ordReceiptData
                .filter(item => checked.includes(item.seqNum))
                .filter(item => allowedTypes.includes(item.dvType));

            if (selectedRows.length === 0) {
                setNonSeaDataSt(true); // 알림 상태 설정
                return null;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            // 선편 양식에 맞게 데이터 매핑
            function mapDataToExcelRowSea(item) {
                console.log("Sea 아이템 : ", item);

                const customs = item.customsDTO;
                const weightInGrams = Math.round(item.shipInfoDTO.weight * 1000);
                const order = item.orderdtDTO;

                const useType = (order.useType === "U0" || order.useType === "U1") ? "Gift" : "Sample";
                const detailAddress = item.appRecDTO.address1 + item.appRecDTO.address2 + item.appRecDTO.address3
                const phoneParts = splitPhoneNumber(item.appRecDTO.telnum);

                const countryCode = item.appRecDTO.countryDTO.countryCode || '';
                // 미국(US) 선편: 우체국은 '.' 없이 숫자 10자리만 허용 (예: 1234.12.1234 → 1234121234)
                let hsCode = customs.customItemDTO.hsCode || '';
                if (countryCode === 'US') {
                    hsCode = String(hsCode).replace(/[^0-9]/g, '').substring(0, 10);
                }

                return {
                    '받는 분 이름': item.appRecDTO.recname?.substring(0, 35) || '',
                    '국가': countryCode,
                    '우편번호': item.appRecDTO.zipcode || '',
                    '받는 분 주소(Detail)': detailAddress?.substring(0, 200) || '',
                    '받는 분 주소(City)': item.appRecDTO.city?.substring(0, 50) || '',
                    '받는 분 주소(State)': 'input', // 'state' 필드 가정
                    '국가번호': phoneParts.g,
                    '지역번호': phoneParts.h,
                    '전화번호1': phoneParts.i,
                    '전화번호2': phoneParts.j,
                    'E-mail': item.orderdtDTO.memberDTO.id?.substring(0, 40) || '', // fetchFedexData 참고
                    '세금식별번호': item.appRecDTO.taxNum || '', // 'taxNum' 필드 가정
                    '부가세 식별번호': item.appRecDTO.vatNum || '', // 'vatNum' 필드 가정
                    '배송편': 'S', // 선편(S)
                    '반송취급': 'N', // 반송없음(N)
                    '보험취급': customs.insrFl ? customs.insrPrice : '', // fetchFedexData 참고 ('insrFl', 'insrPrice' 필드 가정)
                    '서류': useType === 'Document' ? 'O' : '',
                    '상품견본': useType === 'Sample' ? 'O' : '',
                    '선물': useType === 'Gift' ? 'O' : '',
                    '상품': useType === 'Merchandise' ? 'O' : '',
                    '내용품명': customs.custContent?.substring(0, 75) || '',
                    '상품분류번호': hsCode,
                    '개수': customs.custQty || 0,
                    '총 금액': customs.custPrice || 0,
                    '통화코드': 'USD',
                    '순중량(g)': weightInGrams,
                    '생산지': 'KR',
                    // 유럽 PID 컬럼 (우체국 신규 양식 AB~AD, 현재 미구현으로 빈 값 업로드)
                    'M-PID': '',
                    'NS-PID': '',
                    'S-PID': '',
                    '참고사항': ''
                };
            }

            // --- 템플릿 헤더 데이터 정의 (우체국 신규 양식: AB~AD PID 컬럼 추가, 참고사항 AE로 이동) ---
            const row1_Merges_Sea = ['A1:M1', 'N1:O1', 'Q1:AD1'];
            const row1_Values_Sea = {A: '받는 분', N: '배송취급', P: '특수취급', Q: '세관신고서', AE: ''};
            const row2_Values_Sea = [
                '받는 분 이름(Name)', '국가(Country)', '우편번호(ZipCode)', '받는 분 주소(Detail)', '받는 분 주소(City)', '받는 분 주소(State)', '연락처(Mobile No.) 국가번호', '연락처(Mobile No.) 지역번호', '연락처(Mobile No.) 전화번호1', '연락처(Mobile No.) 전화번호2', 'E-mail(필수사항)', '세금식별번호(필수사항)', '부가세 식별번호 (선택사항)', '배송편', '반송취급', '보험취급', '서류(Document)', '상품견본(Sample)', '선물(Gift)', '상품(Merchandise)', '내용품명(Detailed description of contents)', '상품분류번호(HS Tariff Number)', '개수(Quantity)', '총 금액 (Total Value)', '통화코드(Currency Code)', '순중량(g) (Net weigth)', '생산지(Country of Origin)', 'M-PID', 'NS-PID', 'S-PID', '참고사항'
            ];
            const row3_Values_Sea = [
                '영문,공백 최대35글자', '국가코드를 영문 2글자로 입력해주세요', '배달보장서비스국가는 필수입력', '영문,숫자,공백 200글자', '영문,숫자,공백 최대50글자', '영문,숫자,공백 최대50글자', '숫자 최대4글자', '숫자 최대4글자', '숫자 최대4글자', '숫자 최대4글자', '최대40글자', '받는분 국가가 브라질인 경우에만 입력\n수령인 일반개인(자연인) : CPF 번호,\n수령인 법인 : CNPJ번호 입력', '받는분 국가가 \n유럽 27개국 : IOSS 또는 TAX NUMBER 입력, \n영국 : EORI 또는 TAX NUMBER 입력,\n인도네시아 : NPWP 또는 TAX NUMBER 입력,\n그 외 국가 : TAX NUMBER 입력', '항공편 : A\n선편 : S', '반송없음 : N\n항공편반송 : A\n선편반송 : S', '최대 금액 \n4000 SDR 까지 입력가능', '서류, 상품견본, 선물, 상품 중에 1곳에만 "O"표 해주세요\n세관신고서 등록 시, 받는 분이 동일할 때, 4건까지 등록가능합니다.', '', '', '', '필수입력 영어,숫자,공백 75글자까지 입력 가능', '6~10자리 숫자까지 입력 가능', '7자리 숫자\n( 9999999 까지 입력 가능 )', '필수입력\nUSD, EUR, GBP, CNY: 4자리.2자리 숫자( 9999.99 까지 입력 가능 )\nJPY, KRW: 6자리 숫자\n( 999999 까지 입력 가능 )', '필수입력\n(USD, EUR, GBP, JPY, CNY, KRW 입력가능)\n* 내용품이 여러개인 경우 \n가격의 통화코드는 동일해야 합니다.', '10자리 숫자\n( 9999999999 까지 입력 가능 )', '생산지에 해당하는 국가의 국가코드를 2글자 영문으로 입력해주세요', '기업우편물인경우 입력\n(최대 70자리)', '기업우편물인경우 입력\n(최대 70자리)', '기업우편물인경우 입력\n(최대 70자리)', '작성 하실 때 참고하세요'
            ];
            // --- 템플릿 헤더 데이터 정의 끝 ---

            // ✅ [수정] specialHeaders_Sea 정의 (원본 코드에서 복사)
            const specialHeaders_Sea = [
                '받는 분 이름(Name)\n' +
                '영문,공백 최대35글자',
                '국가(Country)\n' +
                '국가코드를 영문 2글자로 입력해주세요',
                '우편번호(ZipCode)\n' +
                '배달보장서비스국가는 필수입력',
                '받는 분 주소(Detail)\n' +
                '영문,숫자,공백 200글자',
                '받는 분 주소(City)\n' +
                '영문,숫자,공백 최대50글자',
                '받는 분 주소(State)\n' +
                '영문,숫자,공백 최대50글자',
                '연락처(Mobile No.) 국가번호\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 지역번호\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 전화번호1\n' +
                '숫자 최대4글자',
                '연락처(Mobile No.) 전화번호2\n' +
                '숫자 최대4글자',
                'E-mail(필수사항)\n' +
                '최대40글자',
                '세금식별번호(필수사항)\n' +
                '받는분 국가가 브라질인 경우에만 입력\n' +
                '수령인 일반개인(자연인) : CPF 번호,\n' +
                '수령인 법인 : CNPJ번호 입력',
                '부가세 식별번호 (선택사항)\n' +
                '받는분 국가가 \n' +
                '유럽 27개국 : IOSS 또는 TAX NUMBER 입력, \n' +
                '영국 : EORI 또는 TAX NUMBER 입력,\n' +
                '인도네시아 : NPWP 또는 TAX NUMBER 입력,\n' +
                '그 외 국가 : TAX NUMBER 입력',
                '배송편\n' +
                '항공편 : A\n' +
                '선편 : S',
                '반송취급\n' +
                '반송없음 : N\n' +
                '항공편반송 : A\n' +
                '선편반송 : S',
                '보험취급\n' +
                '최대 금액 \n' +
                '4000 SDR 까지 입력가능',
                '서류(Document)\n' +
                '서류, 상품견본, 선물, 상품 중에 1곳에만 "O"표 해주세요\n' +
                '세관신고서 등록 시, 받는 분이 동일할 때, 4건까지 등록가능합니다.',
                '상품견본(Sample)',
                '선물(Gift)',
                '상품(Merchandise)',
                '내용품명(Detailed description of contents)\n' +
                '필수입력 영어,숫자,공백 75글자까지 입력 가능',
                '상품분류번호(HS Tariff Number)\n' +
                '6~10자리 숫자까지 입력 가능',
                '개수(Quantity)\n' +
                '7자리 숫자\n' +
                '( 9999999 까지 입력 가능 )',
                '총 금액 (Total Value)\n' +
                '필수입력\n' +
                'USD, EUR, GBP, CNY: 4자리.2자리 숫자( 9999.99 까지 입력 가능 )\n' +
                'JPY, KRW: 6자리 숫자\n' +
                '( 999999 까지 입력 가능 )',
                '통화코드(Currency Code)\n' +
                '필수입력\n' +
                '(USD, EUR, GBP, JPY, CNY, KRW 입력가능)\n' +
                '* 내용품이 여러개인 경우 \n' +
                '가격의 통화코드는 동일해야 합니다.',
                '순중량(g) (Net weigth)\n' +
                '10자리 숫자\n' +
                '( 9999999999 까지 입력 가능 )',
                '생산지(Country of Origin)\n' +
                '생산지에 해당하는 국가의 국가코드를 2글자 영문으로 입력해주세요',
                'M-PID\n' +
                '기업우편물인경우 입력\n' +
                '(최대 70자리)',
                'NS-PID\n' +
                '기업우편물인경우 입력\n' +
                '(최대 70자리)',
                'S-PID\n' +
                '기업우편물인경우 입력\n' +
                '(최대 70자리)',
                '참고사항\n' +
                '작성 하실 때 참고하세요'
            ];

            // ✅ [수정] specialHeaderStyle 정의 (원본 코드에서 복사)
            const specialHeaderStyle = {
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'FFFF0000'} // 빨간색
                }
            };

            // ✅ [수정] sheetConfigs 정의 (원본 코드에서 복사)
            const sheetConfigs = {
                'Sea': {
                    name: '국제소포 파일접수', // 시트 이름 (우체국 신규 양식)
                    columns: [
                        // A-M: 받는분
                        {header: specialHeaders_Sea[0], key: '받는 분 이름', width: 30},
                        {header: specialHeaders_Sea[1], key: '국가', width: 15},
                        {header: specialHeaders_Sea[2], key: '우편번호', width: 20},
                        {header: specialHeaders_Sea[3], key: '받는 분 주소(Detail)', width: 40},
                        {header: specialHeaders_Sea[4], key: '받는 분 주소(City)', width: 25},
                        {header: specialHeaders_Sea[5], key: '받는 분 주소(State)', width: 25},
                        {header: specialHeaders_Sea[6], key: '국가번호', width: 15},
                        {header: specialHeaders_Sea[7], key: '지역번호', width: 15},
                        {header: specialHeaders_Sea[8], key: '전화번호1', width: 15},
                        {header: specialHeaders_Sea[9], key: '전화번호2', width: 15},
                        {header: specialHeaders_Sea[10], key: 'E-mail', width: 30},
                        {header: specialHeaders_Sea[11], key: '세금식별번호', width: 30},
                        {header: specialHeaders_Sea[12], key: '부가세 식별번호', width: 30},
                        // N-O: 배송취급
                        {header: specialHeaders_Sea[13], key: '배송편', width: 15},
                        {header: specialHeaders_Sea[14], key: '반송취급', width: 15},
                        // P: 특수취급
                        {header: specialHeaders_Sea[15], key: '보험취급', width: 20},
                        // Q-AA: 세관신고서
                        {header: specialHeaders_Sea[16], key: '서류', width: 25},
                        {header: specialHeaders_Sea[17], key: '상품견본', width: 10},
                        {header: specialHeaders_Sea[18], key: '선물', width: 10},
                        {header: specialHeaders_Sea[19], key: '상품', width: 10},
                        {header: specialHeaders_Sea[20], key: '내용품명', width: 30},
                        {header: specialHeaders_Sea[21], key: '상품분류번호', width: 20},
                        {header: specialHeaders_Sea[22], key: '개수', width: 15},
                        {header: specialHeaders_Sea[23], key: '총 금액', width: 25},
                        {header: specialHeaders_Sea[24], key: '통화코드', width: 25},
                        {header: specialHeaders_Sea[25], key: '순중량(g)', width: 20},
                        {header: specialHeaders_Sea[26], key: '생산지', width: 25},
                        // AB-AD: 유럽 PID (우체국 신규 양식, 미구현으로 빈 값)
                        {header: specialHeaders_Sea[27], key: 'M-PID', width: 20},
                        {header: specialHeaders_Sea[28], key: 'NS-PID', width: 20},
                        {header: specialHeaders_Sea[29], key: 'S-PID', width: 20},
                        // AE: 참고사항
                        {header: specialHeaders_Sea[30], key: '참고사항', width: 30}
                    ],
                }
            };

            // ✅ [수정] borderHeaderStyle 정의 (원본 코드에서 복사)
            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            // --- 스타일 및 폰트 정의 ---
            const alignmentCenter = {horizontal: 'center', vertical: 'middle', wrapText: true};
            const fontBold = {name: '맑은 고딕', bold: true, size: 10};
            const fontNormal = {name: '맑은 고딕', size: 10};

            // 데이터 변환
            let transformedSelectedRows = selectedRows.map(mapDataToExcelRowSea);

            // 시트 생성 및 설정
            if (sheetConfigs) {
                // ✅ [수정] config가 undefined인지 확인
                const config = sheetConfigs['Sea'];
                if (!config) {
                    console.error("Sea sheet configuration not found.");
                    return;
                }

                const sheet = workbook.addWorksheet(config.name); // 오류 발생 지점
                const columnsConfig = config.columns;

                // 1. 컬럼 설정 (키, 너비 매핑용)
                sheet.columns = columnsConfig;

                // 2. 1행 (병합 타이틀) 생성
                row1_Merges_Sea.forEach(merge => sheet.mergeCells(merge));
                const row1 = sheet.getRow(1);
                row1.height = 20;
                Object.keys(row1_Values_Sea).forEach(cellKey => {
                    sheet.getCell(cellKey + '1').value = row1_Values_Sea[cellKey];
                });
                row1.eachCell({includeEmpty: true}, cell => {
                    cell.font = fontBold;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                });

                // 3. 2행 (헤더명) 생성
                const row2 = sheet.getRow(2);
                row2.values = row2_Values_Sea;
                row2.height = 60;
                row2.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = fontBold;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                    // 빨간 배경 적용
                    const colConfigHeader = columnsConfig[colNumber - 1]?.header;
                    if (specialHeaders_Sea.includes(colConfigHeader)) {
                        cell.fill = specialHeaderStyle.fill;
                    }
                });

                // 4. 3행 (제한조건) 생성
                const row3 = sheet.getRow(3);
                row3.values = row3_Values_Sea;
                row3.height = 120; // 텍스트 줄바꿈을 위해 충분한 높이
                row3.eachCell({includeEmpty: true}, (cell, colNumber) => {
                    cell.font = fontNormal;
                    cell.alignment = alignmentCenter;
                    cell.border = borderHeaderStyle;
                    // 빨간 배경 적용
                    const colConfigHeader = columnsConfig[colNumber - 1]?.header;
                    if (specialHeaders_Sea.includes(colConfigHeader)) {
                        cell.fill = specialHeaderStyle.fill;
                    }
                });
                // 우체국 신규 양식: 세관신고서 안내문구(Q3~T3) 병합
                sheet.mergeCells('Q3:T3');

                // 5. 4행부터 데이터 추가 (가운데 정렬 포함)
                transformedSelectedRows.forEach((item, index) => {
                    const row = sheet.addRow(item); // 4행부터 데이터 시작
                    row.eachCell({includeEmpty: true}, (cell) => {
                        cell.font = fontNormal;
                        cell.border = borderHeaderStyle;
                        cell.alignment = alignmentCenter; // 문제 3 해결: 데이터 셀 가운데 정렬
                    });
                });
            }

            // 파일명 생성 및 다운로드
            const payInfo = selectedRows[0];
            const name = payInfo.appRecDTO.recname;
            const shipco = convertToShipco(payInfo.dvType);
            const orderNum = payInfo.orderdtDTO.orderNumber;

            let fileName = `${shipco}_${orderNum}_${name}_Invoice.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        } catch (error) {
            console.error("Sea 엑셀 다운로드 중 오류 발생:", error);
        } finally {
            setChecked([]);
            setShipcoChecked([]);
        }
    };

    // ✅ 전화번호 분배 헬퍼 함수
    function splitPhoneNumber(telnum) {
        // 숫자 외 모든 문자 제거 (하이픈, 공백 등)
        const numStr = String(telnum || '').replace(/\D/g, '');
        const totalLength = numStr.length;
        const numSlots = 4; // 4개의 열(G, H, I, J)

        if (totalLength === 0) {
            return {g: '', h: '', i: '', j: ''};
        }

        const baseLength = Math.floor(totalLength / numSlots);
        const remainder = totalLength % numSlots;

        const lengths = [];
        for (let k = 0; k < numSlots; k++) {
            // (4 - remainder)개 만큼은 baseLength,
            // (remainder)개 만큼은 baseLength + 1
            // 예: 10자리 -> base: 2, remainder: 2
            // k=0: k < (4-2=2) -> true. lengths=[2]
            // k=1: k < 2 -> true. lengths=[2, 2]
            // k=2: k < 2 -> false. lengths=[2, 2, 3]
            // k=3: k < 2 -> false. lengths=[2, 2, 3, 3] (2, 2, 3, 3 분배)
            if (k < numSlots - remainder) {
                lengths.push(baseLength);
            } else {
                lengths.push(baseLength + 1);
            }
        }

        let currentIndex = 0;
        const g = numStr.substring(currentIndex, currentIndex + lengths[0]);
        currentIndex += lengths[0];

        const h = numStr.substring(currentIndex, currentIndex + lengths[1]);
        currentIndex += lengths[1];

        const i = numStr.substring(currentIndex, currentIndex + lengths[2]);
        currentIndex += lengths[2];

        const j = numStr.substring(currentIndex); // 나머지 (lengths[3] 만큼)

        return {g, h, i, j};
    }

    const [errorInvoiceMsg, setErrorInvoiceMsg] = useState('');

    const invoiceDown = async () => {
        try {
            // ✅ [수정 1] AdminDashBoardPg와 달리 ordReceiptData에서 직접 checked된 데이터를 선택
            const selectedRows = ordReceiptData.filter((item) => checked.includes(item.seqNum));

            console.log("다운된 데이터 : ", selectedRows);

            if (selectedRows.length === 0) {
                setErrorInvoiceMsg('데이터를 선택해주세요');
                setTimeout(() => setErrorInvoiceMsg(''), 1500);
                return;
            }

            const excel = require('exceljs');

            for (let i = 0; i < selectedRows.length; i++) {
                const rowData = selectedRows[i];
                const workbook = new excel.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();

                const worksheet = workbook.addWorksheet('Invoice');

                //region dataSet

                // ✅ [수정 1] rowData.type 체크 제거 (무조건 payinfo 타입으로 간주)
                let userName = rowData.orderdtDTO.memberDTO.userName || '';

                // ✅ [수정 1] rowData.type 체크 제거
                const orderNumber = rowData.orderdtDTO?.orderNumber || '';
                const boxNum = rowData.shipInfoDTO?.boxNum || '0';
                let orderNo = `${orderNumber}-${boxNum}`;

                // endregion

                // region 열너비 & 행높이 (기존과 동일)
                //열너비
                worksheet.getColumn('A').width = 0.8;
                worksheet.getColumn('B').width = 13;
                worksheet.getColumn('C').width = 13;
                worksheet.getColumn('D').width = 13;
                worksheet.getColumn('E').width = 25;
                worksheet.getColumn('F').width = 23;
                worksheet.getColumn('G').width = 11;
                worksheet.getColumn('H').width = 15;
                worksheet.getColumn('I').width = 15;

                //행높이
                worksheet.getRow(1).height = 4;
                worksheet.getRow(2).height = 29;
                worksheet.getRow(3).height = 4;
                worksheet.getRow(4).height = 29;
                worksheet.getRow(5).height = 4;

                for (let row = 6; row <= 13; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(11).height = 10;
                worksheet.getRow(20).height = 4;
                worksheet.getRow(21).height = 32;
                for (let row = 22; row <= 56; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(57).height = 20;

                // endregion

                // region 엑셀내용 (스타일 및 정적 데이터)

                const thinBorder = {style: 'thin'};

                worksheet.mergeCells('B2:I2');
                const titleCell = worksheet.getCell('B2');
                titleCell.value = 'INVOICE';
                titleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                titleCell.font = {name: 'Arial', size: 18, bold: true};
                const borderStyle = {style: 'medium'};
                worksheet.getCell('B2').border = {
                    top: borderStyle,
                    bottom: borderStyle,
                };

                worksheet.mergeCells('B4:C4');
                const lcWaybillCell = worksheet.getCell('B4');
                lcWaybillCell.value = 'L/C No. and Waybill No.';
                lcWaybillCell.alignment = {vertical: 'middle', horizontal: 'right'};
                lcWaybillCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('D4:E4');
                const waybillValueCell = worksheet.getCell('D4');

                // ✅ [수정 1] rowData.type 체크 제거
                waybillValueCell.value = rowData.shipInfoDTO.outWayNum || ''; // outWayNum은 payinfo에만 있음

                waybillValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                waybillValueCell.font = {name: 'Arial', size: 13, bold: true, italic: true};

                worksheet.mergeCells('F4:H4');
                const exportDateTitleCell = worksheet.getCell('F4');
                exportDateTitleCell.value = 'Date of Exportation.';
                exportDateTitleCell.alignment = {vertical: 'middle', horizontal: 'right'};
                exportDateTitleCell.font = {name: 'Arial', size: 12, bold: true};

                const today = new Date();
                const monthShort = today.toLocaleString('en-US', {month: 'short'});
                const day = String(today.getDate()).padStart(2, '0');
                const year = today.getFullYear();
                const formattedToday = `${monthShort}-${day}-${year}`;
                const exportDateValueCell = worksheet.getCell('I4');
                exportDateValueCell.value = formattedToday;
                exportDateValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                exportDateValueCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('B6:E6');
                const shipperCell = worksheet.getCell('B6');
                shipperCell.value = 'Shipper / Exporter';
                shipperCell.alignment = {vertical: 'middle', horizontal: 'center'};
                shipperCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F6:I6');
                const consigneeCell = worksheet.getCell('F6');
                consigneeCell.value = 'Consignee';
                consigneeCell.alignment = {vertical: 'middle', horizontal: 'center'};
                consigneeCell.font = {name: 'Arial', size: 12, bold: true};

                for (let row = 7; row <= 13; row++) {
                    worksheet.mergeCells(`B${row}:E${row}`);
                }

                for (let row = 7; row <= 19; row++) {
                    worksheet.getCell(`F${row}`).border = {
                        left: thinBorder,
                    };
                }

                worksheet.getCell('E6').border = {right: thinBorder,};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}5`).border = {bottom: thinBorder};
                    worksheet.getCell(`${col}14`).border = {top: thinBorder};
                    worksheet.getCell(`${col}57`).border = {top: thinBorder, bottom: thinBorder};
                }

                const skyBlue = {argb: 'FFE5EEFF'};
                const lightGray = {argb: 'FFF0F0F0'};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}6`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let row = 14; row <= 19; row++) {
                    for (let col of ['B', 'C', 'D']) {
                        worksheet.getCell(`${col}${row}`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                    }
                }

                for (let col of ['F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}14`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}21`).fill = {type: 'pattern', pattern: 'solid', fgColor: lightGray};
                }

                // endregion

                // region 발송인 (기존과 동일 - 정적 데이터)
                worksheet.getCell('B7').value = 'IMEUNWOO(individual)';
                worksheet.getCell('B7').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B7').font = {name: 'Arial', size: 11};

                worksheet.getCell('B8').value = '32-15, Yeongok-gil 42beon-gil, Gonjiam-eup,';
                worksheet.getCell('B8').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B8').font = {name: 'Arial', size: 11};

                worksheet.getCell('B9').value = 'Gwangji-si, Gyeonggi-do (zipcode 12722)';
                worksheet.getCell('B9').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B9').font = {name: 'Arial', size: 11};

                worksheet.getCell('B10').value = 'Tel: 82-10-3338-9354';
                worksheet.getCell('B10').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B10').font = {name: 'Arial', size: 11};

                worksheet.getCell('B12').value = '(empty)';
                worksheet.getCell('B12').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B12').font = {name: 'Arial', size: 11};

                worksheet.getCell('B13').value = '(empty)';
                worksheet.getCell('B13').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B13').font = {name: 'Arial', size: 11};
                // endregion

                // region 수취인

                // ✅ [수정 1] rowData.type 체크 제거
                const receiver = rowData.appRecDTO; // payinfo 타입이므로 appRecDTO 사용

                const fullAddress =
                    (receiver?.address1 || '') +
                    (receiver?.address2 || '') +
                    (receiver?.address3 || '');

                const cityZipcode =
                    (receiver?.city || '') +
                    ' (zipcode ' + (receiver?.zipcode || '') + ')';

                worksheet.mergeCells('F7:I13');
                const mergedCell = worksheet.getCell('F7');

                mergedCell.value =
                    (receiver?.recname || '') + '\n' +
                    fullAddress + '\n' +
                    cityZipcode + '\n\n' +
                    'Tel: ' + (receiver?.telnum || '');

                mergedCell.alignment = {vertical: 'top', horizontal: 'left', wrapText: true};
                mergedCell.font = {name: 'Arial', size: 11};

                //수취인과 다를경우 직접입력
                worksheet.mergeCells('F15:I19');
                const mergedBuyerCell = worksheet.getCell('F15');
                mergedBuyerCell.value = '';
                mergedBuyerCell.alignment = {vertical: 'middle', horizontal: 'left'};
                mergedBuyerCell.font = {name: 'Arial', size: 11};

                // endregion

                // region 기타정보
                worksheet.mergeCells('B14:D15');
                const countryExportCell = worksheet.getCell('B14');
                countryExportCell.value = 'Country of Export';
                countryExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                countryExportCell.font = {name: 'Arial', size: 11, bold: true};
                countryExportCell.border = {top: thinBorder};

                worksheet.mergeCells('F14:I14');
                const buyerCell = worksheet.getCell('F14');
                buyerCell.value = 'Buyer (if other than consignee)';
                buyerCell.alignment = {vertical: 'middle', horizontal: 'center'};
                buyerCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('B16:D17');
                const reasonExportCell = worksheet.getCell('B16');
                reasonExportCell.value = 'Reason for Export';
                reasonExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                reasonExportCell.font = {name: 'Arial', size: 11, bold: true};
                reasonExportCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('E14:E15');
                const koreaCell = worksheet.getCell('E14');
                koreaCell.value = 'Republic of Korea [KR]';
                koreaCell.alignment = {vertical: 'middle', horizontal: 'center'};
                koreaCell.font = {name: 'Arial', size: 11};
                koreaCell.border = {bottom: thinBorder};
                koreaCell.border = {top: thinBorder};

                worksheet.mergeCells('E16:E17');
                const giftCell = worksheet.getCell('E16');
                giftCell.value = 'e.g.personal gift';
                giftCell.alignment = {vertical: 'middle', horizontal: 'center'};
                giftCell.font = {name: 'Arial', size: 11};
                giftCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('B18:D19');
                const destinationTitleCell = worksheet.getCell('B18');
                destinationTitleCell.value = 'Country of Ultimate Destination';
                destinationTitleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationTitleCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('E18:E19');
                const destinationCountryCell = worksheet.getCell('E18');

                // ✅ [수정 1] rowData.type 체크 제거
                let destinationCountry =
                    (rowData.appRecDTO.countryDTO.countryEngNm || '') +
                    ' [' + (rowData.appRecDTO.countryDTO.countryCode || '') + ']';

                destinationCountryCell.value = destinationCountry;
                destinationCountryCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationCountryCell.font = {name: 'Arial', size: 10};

                // endregion

                // region 상품 목록 헤더 (기존과 동일)
                worksheet.mergeCells('B20:I20');
                const GbnCell = worksheet.getCell('B20');
                GbnCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.getCell('B21').value = 'Country of Origin';
                worksheet.getCell('B21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('B21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C21').value = 'Pkgs / Type';
                worksheet.getCell('C21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('D21:F21');
                worksheet.getCell('D21').value = 'Description of Goods';
                worksheet.getCell('D21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('D21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('G21').value = 'Qty / Unit';
                worksheet.getCell('G21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('G21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('H21').value = 'Qty / Unit Price(USD)';
                worksheet.getCell('H21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('H21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('I21').value = 'Total Amount(USD)';
                worksheet.getCell('I21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('I21').font = {name: 'Arial', size: 11, bold: true};

                for (let row = 22; row <= 56; row++) {
                    worksheet.mergeCells(`D${row}:F${row}`);
                }

                for (let row = 21; row <= 56; row++) {
                    for (let col of ['B', 'C', 'D', 'G', 'H']) {
                        worksheet.getCell(`${col}${row}`).border = {
                            right: thinBorder,
                        };
                    }
                }

                worksheet.getCell('B22').value = 'KR';
                worksheet.getCell('B22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('B22').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C22').value = '1 / cartons';
                worksheet.getCell('C22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C22').font = {name: 'Arial', size: 11, bold: true};
                // endregion

                // region 상품 목록 매핑 (✅ [수정 2])
                const startRow = 22;

                // ✅ [수정 2] packListDTO 대신 customsDTO.customItemsDTO 사용
                let customsItems = rowData.customsDTO.customItemsDTO || [];

                // ✅ [수정 2] fetchFedexData 로직(Case 2)처럼, 자식 아이템이 없으면 부모 customsDTO를 사용
                if (customsItems.length === 0 && rowData.customsDTO.custContent) {
                    customsItems = [{
                        content: rowData.customsDTO.custContent,
                        quantity: rowData.customsDTO.custQty,
                        price: rowData.customsDTO.custPrice, // fetchFedexData Case 2 기준: Total Price (USD)
                        ttPrice: rowData.customsDTO.custPrice // fetchFedexData Case 2 기준: Total Price (USD)
                    }];
                }

                // ✅ [수정 2] customsItems를 순회하며 데이터 매핑
                customsItems.forEach((item, index) => {
                    const row = startRow + index;
                    if (row > 56) return; // 최대 35개 항목

                    const quantity = Number(item.quantity) || 0;

                    // fetchFedexData 로직(Case 1) 기준:
                    // item.price (Total) / quantity = Unit Price
                    // item.ttPrice = Total Price
                    // (price와 ttPrice가 동일한 Total Price일 가능성이 높음)
                    const totalUSD = Number(item.ttPrice) || Number(item.price) || 0;
                    const unitPriceUSD = (quantity > 0) ? (totalUSD / quantity) : 0;

                    // D열 (Description of Goods)
                    worksheet.getCell(`D${row}`).value = item.content || ''; // 'name' 대신 'content'
                    worksheet.getCell(`D${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`D${row}`).font = {name: 'Arial', size: 11};

                    // G열 (Qty / Unit)
                    worksheet.getCell(`G${row}`).value = quantity.toLocaleString();
                    worksheet.getCell(`G${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`G${row}`).font = {name: 'Arial', size: 11};

                    // H열 (Unit Price) - USD 기준
                    worksheet.getCell(`H${row}`).value = unitPriceUSD;
                    worksheet.getCell(`H${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`H${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`H${row}`).numFmt = '"$"#,##0.00';

                    // I열 (Total Amount) - USD 기준
                    worksheet.getCell(`I${row}`).value = totalUSD;
                    worksheet.getCell(`I${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`I${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`I${row}`).numFmt = '"$"#,##0.00';
                });

                // ✅ [수정 2] totalQty 계산 기준 변경
                const totalQty = customsItems.reduce((sum, item) => {
                    return sum + (Number(item.quantity) || 0);
                }, 0);

                worksheet.getCell('G57').value = `${totalQty} EA`;
                worksheet.getCell('G57').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('G57').font = {name: 'Arial', size: 12, bold: true};

                worksheet.getCell('I57').value = {formula: 'SUM(I22:I56)'};
                worksheet.getCell('I57').alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                worksheet.getCell('I57').font = {name: 'Arial', size: 12, bold: true};
                worksheet.getCell('I57').numFmt = '"$"#,##0.00';

                const totalCell = worksheet.getCell('F57');
                totalCell.value = 'Total';
                totalCell.alignment = {vertical: 'middle', horizontal: 'right'};
                totalCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F60:F61');

                const signedByCell = worksheet.getCell('F60');
                signedByCell.value = 'Signed By.';
                signedByCell.alignment = {vertical: 'bottom', horizontal: 'right'};
                signedByCell.font = {name: 'Arial', size: 11};

                const signatureNameCell = worksheet.getCell('I61');
                signatureNameCell.value = 'IMEUNWOO';
                signatureNameCell.alignment = {vertical: 'bottom', horizontal: 'center'};
                signatureNameCell.font = {name: 'Arial', size: 12, bold: true};

                for (let col of ['G', 'H', 'I']) {
                    worksheet.getCell(`${col}61`).border = {
                        bottom: thinBorder,
                    };
                }
                // endregion

                // region 다운로드 (기존과 동일)
                worksheet.pageSetup.printArea = 'A1:I61';

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `[${userName}님]인보이스_${orderNo}_${DateViewValue}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
                // endregion
            }
        } catch (error) {
            console.error("인보이스 다운로드 중 오류 발생:", error);
            setErrorInvoiceMsg('인보이스 생성 중 오류가 발생했습니다.');
            setTimeout(() => setErrorInvoiceMsg(''), 1500);
        } finally {
            setChecked([]);
            setShipcoChecked([]);
        }
    };


    const generateState = () => {
        const today = new Date();
        const year = today.getFullYear().toString().slice(2); // 연도 마지막 2자리
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // 월 (2자리)
        const day = today.getDate().toString().padStart(2, '0'); // 일 (2자리)

        const dateString = `${year}${month}${day}`; // yyMMdd 형식
        const randomLong = Math.floor(Math.random() * 10_000); // 4자리 랜덤 숫자
        const randomNumber = randomLong.toString().padStart(10, '0');
        return dateString + randomNumber;
    }

    const [fedexLiveAccountNum, setFedexLiveAccountNum] = useState(null);
    const selectedLiveFedexAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/liveFedexAccount');
            setFedexLiveAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Live FedEx Account:', error);
        }
    };
    const [fedexSandboxAccountNum, setFedexSandboxAccountNum] = useState(null);
    const selectedSandboxFedexAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/sandboxFedexAccount');
            setFedexSandboxAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Sandbox FedEx Account:', error);
        }
    };

    const [upsLiveAccountNum, setUpsLiveAccountNum] = useState(null);
    const selectedLiveUpsAccount = async () => {
        try {
            const response = await axios.get('/credentials/secretManager/liveUpsAccount');
            setUpsLiveAccountNum(response.data);
        } catch (error) {
            console.error('Failed to Selected Live UPS Account:', error);
        }
    };

    useEffect(() => {
        // selectedSandboxFedexAccount();
        selectedLiveFedexAccount();
        selectedLiveUpsAccount();
    }, []);

    // FedEx API
    const [fedexErrorList, setFedexErrorList] = useState([]);
    const fedexConnectApi = async () => {
        if (isLoading) return;

        setIsLoading(true);
        setFedexErrorList([]);
        const fetchData = await fetchFedexData();

        if (fetchData.length === 0) {
            console.log("FetchData null error")
            return;
        }

        console.log("호출 직전 FedEx Fetch Data : ", fetchData)

        try {
            const response = await axios({
                method: 'post',
                url: `/externalApi/fedexReceipt`,
                data: fetchData,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: LCAT
                }
            });

            const data = response.data;

            let successCount = 0;
            let errorList = [];

            for (const result of data) {
                if (result.error) {
                    // 실패 항목 저장
                    errorList.push({
                        seqNum: result.paySeqNum,
                        code: result.errorCode,
                        message: result.errorMessage
                    });
                } else {
                    // 성공 처리
                    try {
                        // // ZPL 데이터가 있는지 확인하고 인쇄 함수 호출
                        if (result.zplLabelData) {
                            printZplWithBrowserPrint(result.zplLabelData);
                        } else {
                            console.warn("ZPL 라벨 데이터가 없습니다:", result.paySeqNum);
                        }

                        await sendMessage(result);
                        console.log("fetchData : ", fetchData)
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: result?.orderdtDTO?.memberDTO?.mbNum}));
                        successCount++;
                    } catch (err) {
                        console.error("메시지 전송 오류:", err);
                    }
                }
            }

            // 결과 요약
            if (errorList.length > 0) {
                setFedexErrorList(errorList); // 오류 상태 업데이트
            } else {
                setFedexErrorList([]); // 오류 없으면 초기화
            }

        } catch (error) {
            console.error('FedEx API 요청 실패:', {
                message: error.message,
                data: error.response?.data,
                status: error.response?.status,
            });

            const errorResponse = error.response?.data;
            if (errorResponse?.error) {
                setFedexErrorList([
                    {
                        seqNum: '전체',
                        code: errorResponse.errorCode || 'UNKNOWN',
                        message: errorResponse.errorMessage || 'UPS API 오류'
                    }
                ]);
            } else {
                setFedexErrorList([
                    {
                        seqNum: '전체',
                        code: 'NETWORK',
                        message: '서버 응답 실패 또는 네트워크 오류'
                    }
                ]);
            }
        } finally {
            setAlertShowFedex(false);
            setIsLoading(false);
            window.scrollTo({top: 0, behavior: 'smooth'});
            if (fedexErrorList.length === 0) {
                // 추후 추가쿼리 날리지 않고 반환된 접수 seqNum === 접수리스트 데이터 seqNum 매칭 후 업뎃
                ordReceiptSelect();
            }
        }
    };

    // FedEx 접수양식필드
    const fetchFedexData = async () => {
        if (!ordReceiptData || ordReceiptData.length === 0) return [];
        const selected = ordReceiptData.filter((apiData) => checked.includes(apiData.seqNum));

        return await Promise.all(selected.map(async row => {
            const member = row.orderdtDTO.memberDTO;
            const order = row.orderdtDTO;
            const customs = row.customsDTO;
            const shipInfo = row.shipInfoDTO;
            const customItems = customs.customItemsDTO || [];
            const parentCurrency = customs.custCurrency || "USD"; // 부모 통화

            const {address1, address2, address3, zipcode, recname, city, telnum} = row.appRecDTO;
            const countryCode = row.appRecDTO.countryDTO.countryCode;
            const isSignatureRequiredCountry = ["DE", "FR", "IT", "ES", "PL", "SG"].includes(countryCode); // 해당 국가들은 수령시 서명여부 필드자체를 지원 X
            const isDeliveryAlarm = row.appReqDTO?.deliveryAlarm === true;

            const rawTaxId = row.appRecDTO.taxid || '';
            const hasIndoTaxId = (countryCode === 'ID' && rawTaxId.trim().length > 0);
            const taxIdValue = hasIndoTaxId ? rawTaxId.trim() : null;

            const fullAddress = [address1, address2, address3].filter(Boolean).join(' ');
            const streetLines = [];
            let remainingAddress = fullAddress.trim();
            const maxLines = 3; // FedEx API는 보통 streetLines를 2-3개까지 지원
            const maxLength = 35;
            while (remainingAddress.length > 0 && streetLines.length < maxLines) {
                // 남은 주소가 35자 이하면 그대로 추가하고 종료
                if (remainingAddress.length <= maxLength) {
                    streetLines.push(remainingAddress);
                    remainingAddress = '';
                    break;
                }
                // 35자 이내에서 단어가 잘리지 않도록 마지막 공백 위치를 찾음
                let splitIndex = remainingAddress.substring(0, maxLength + 1).lastIndexOf(' ');
                // 만약 35자 이내에 공백이 없다면 (예: 매우 긴 단어), 그냥 35자에서 자름
                if (splitIndex <= 0) {
                    splitIndex = maxLength;
                }
                const line = remainingAddress.substring(0, splitIndex);
                streetLines.push(line);
                remainingAddress = remainingAddress.substring(splitIndex).trim();
            }
            // streetLines 배열(최대 3줄)을 채우고도 남은 주소가 있다면, 기존 city 정보 앞에 추가
            const finalCity = remainingAddress.length > 0 ? `${remainingAddress} ${city}`.trim() : city;
            // const stateProvinceCode = (countryCode === 'US' || countryCode === 'CA' || countryCode === 'PR') ? await getStateCodeFromZip(zipcode, countryCode) : "";
            const stateProvinceCode = "";

            const useType = order.useType === "U0" ? "GIFT" : order.useType === "U1" ? "SOLD" : "SAMPLE"
            const residential = (order.useType === "U0" || order.useType === "U1");

            const length = Number(shipInfo.wid) || 0;
            const width = Number(shipInfo.ver) || 0;
            const height = Number(shipInfo.hei) || 0;

            // 기본적으로 ETD는 항상 포함
            const activeSpecialServiceTypes = ["ELECTRONIC_TRADE_DOCUMENTS"];
            // 고객이 알림을 요청했다면 배열에 추가
            if (isDeliveryAlarm) {
                activeSpecialServiceTypes.push("EVENT_NOTIFICATION");
            }

            // 수취인주소
            const recipientAddress = {
                streetLines: streetLines,
                city: finalCity,
                stateOrProvinceCode: stateProvinceCode,
                postalCode: zipcode || "",
                countryCode: countryCode || "",
                residential: false
                // residential: residential // true면 거주지, false면 회사(상업용) 또는 거주지 X
            };

            const totalWeightValue = parseFloat(shipInfo.weight) || 0;
            // 자식아이템 세관신고금액 총합
            const totalItemsValue = customItems.reduce((sum, item) => sum + (item.ttPrice || 0), 0);

            let commodities;
            let totalCustomsValue;

            // CASE 1: 여러 상품이 있고 총합 금액이 0보다 클 경우
            if (customItems.length > 0 && totalItemsValue > 0) {
                // 총 세관신고금액 기준으로 commodities 개별 자식아이템 개수만큼 평균무게계산
                const averageItemWeight = customItems.length > 0 ? totalWeightValue / customItems.length : 0;
                // 계산된 상품당 무게의 합이 totalWeight를 초과하지 않도록 소숫점 한 자리 수 외에 전부 제거
                const truncatedAvgWeight = Math.trunc(averageItemWeight * 10) / 10;

                commodities = customItems.map(childItem => {
                    // const qty = Number(childItem.quantity) || 0;
                    // const price = Number(childItem.price) || 0;
                    // const numericUnitPrice = (qty > 0) ? Math.trunc((price / qty) * 100) / 100 : 0;
                    // const itemCurrency = childItem.currency || parentCurrency;

                    const qty = Number(childItem.quantity) || 1;
                    const totalItemPrice = Number(childItem.ttPrice) || (Number(childItem.price || 0) * qty);
                    const calUnitPrice = Number((totalItemPrice / qty).toFixed(5));
                    const calTotalValue = Number((calUnitPrice * qty).toFixed(5));
                    const itemCurrency = childItem.currency || parentCurrency;

                    return {
                        description: childItem.content,
                        harmonizedCode: childItem.hscode,
                        quantity: qty,
                        quantityUnits: "PCS",
                        unitPrice: {amount: calUnitPrice, currency: itemCurrency}, // 👈 계산된 정수/소숫점 단가로 대입
                        countryOfManufacture: "KR",
                        weight: {units: "KG", value: truncatedAvgWeight},
                        customsValue: {amount: calTotalValue, currency: itemCurrency},
                        // 제조사정보(MID)
                        clearanceItemDetail: [
                            {
                                role: "MANUFACTURER", // 제조업체
                                contact: {
                                    companyName: childItem.mcNm || "BTORAGE CO LTD",
                                },
                                address: {
                                    streetLines: [childItem.mcAddress || "32-15 Yeongok-gil"],
                                    postalCode: childItem.mcZipcode || "12722",
                                    countryCode: "KR"
                                }
                            }
                        ]
                    };
                });
                totalCustomsValue = totalItemsValue;

                // CASE 2: 단일 상품이거나, 여러 상품이지만 가격 정보가 없을 때
            } else {
                // const parentMid = customs.customItemDTO; // 부모 customsDTO에 연결된 customItemDTO에서 가져옴
                // // ✅ 단가계산
                // const qty = Number(customs.custQty) || 0;
                // const price = Number(customs.custPrice) || 0;
                // // 단가 계산 후 소수점 3자리부터 절삭 (숫자) & 소숫점 2자리까지 기준으로 마지막 자릿수가 0이 아닐 때까지 절삭
                // const numericUnitPrice = (qty > 0) ? Math.trunc((price / qty) * 100000) / 100000 : 0;

                const parentMid = customs.customItemDTO;
                const qty = Number(customs.custQty) || 1;
                const originalTotalPrice = Number(customs.custPrice) || 0;
                // 1. 단가 역산
                const calUnitPrice = Number((originalTotalPrice / qty).toFixed(5));
                // 2. 총액 재계산 (단가 * 수량)
                const calTotalValue = Number((calUnitPrice * qty).toFixed(5));

                commodities = [{
                    description: customs.custContent,
                    harmonizedCode: parentMid.hscode,
                    quantity: qty,
                    quantityUnits: "PCS",
                    unitPrice: {amount: calUnitPrice, currency: parentCurrency}, // 👈 계산된 정수/소숫점 단가로 대입
                    countryOfManufacture: "KR",
                    weight: {units: "KG", value: totalWeightValue || 0},
                    customsValue: {amount: calTotalValue, currency: parentCurrency},
                    // 제조사정보(MID)
                    clearanceItemDetail: [
                        {
                            role: "MANUFACTURER", // 제조업체
                            contact: {
                                companyName: parentMid?.mcNm || "BTORAGE CO LTD",
                            },
                            address: {
                                streetLines: [parentMid?.mcAddress || "32-15 Yeongok-gil"],
                                postalCode: parentMid?.mcZipcode || "12722",
                                countryCode: "KR"
                            }
                        }
                    ]
                }];
                totalCustomsValue = customs.custPrice;
            }

            // FedEx-E일 경우 관부가세 선납여부 상관없이 비토리지가 관세선지불
            const isFedexEco = row.dvType === "D16";
            const serviceType = isFedexEco ? "FEDEX_INTERNATIONAL_CONNECT_PLUS" : "FEDEX_INTERNATIONAL_PRIORITY";
            const needsCusPrepay = row.appReqDTO?.cusPrepayFl === true || isFedexEco;

            return {
                mergeLabelDocOption: "LABELS_AND_DOCS",
                requestedShipment: {
                    shipDatestamp: new Date().toISOString().slice(0, 10),
                    totalDeclaredValue: {
                        amount: totalCustomsValue,
                        currency: parentCurrency
                    },
                    shipper: {
                        // Btorage 기본 발송인 (고정)
                        address: {
                            streetLines: ["32-15 Yeongok-gil 42beon-gil"],
                            city: "Gonjiam-eup Gwangjusi",
                            stateOrProvinceCode: "Gyeonggi",
                            postalCode: "12722",
                            countryCode: "KR",
                            residential: false
                        },
                        contact: {
                            personName: "IMEUNWOO",
                            emailAddress: "help@btorage.com",
                            phoneNumber: "821033389354",
                            companyName: "Btorage"
                        }
                    },
                    recipients: [
                        {
                            address: recipientAddress,
                            contact: {
                                personName: recname,
                                emailAddress: member.id,
                                phoneNumber: telnum,
                                companyName: ""
                            },
                            ...(hasIndoTaxId && {
                                tins: [
                                    {
                                        number: taxIdValue,
                                        tinType: "BUSINESS_NATIONAL", // 개인은 PERSONAL_NATIONAL(보통 BUSINESS_NATIONAL로 통용됨)
                                        usage: "USAGE_OR_IMPORT"
                                    }
                                ]
                            })
                        }
                    ],
                    pickupType: "USE_SCHEDULED_PICKUP", // ✅ 필수 항목
                    serviceType: serviceType,
                    packagingType: row.shipInfoDTO.fedexPack === '1' ? "FEDEX_PAK" : "YOUR_PACKAGING",
                    totalWeight: totalWeightValue,
                    totalPackageCount: 1,
                    shippingChargesPayment: {
                        paymentType: "SENDER",
                        payor: {
                            responsibleParty: {
                                contact: {
                                    "personName": "IMEUNWOO",
                                    "emailAddress": "hcm@btorage.com",
                                    "phoneNumber": "821033389354"
                                },
                                accountNumber: {"value": String(fedexLiveAccountNum)}
                            }
                        }
                    },
                    customsClearanceDetail: {
                        commodities: commodities,
                        commercialInvoice: {
                            originatorName: "IMEUNWOO",
                            // DDP:운송비+관세 등 모든 비용을 발송인이 부담 | DAP:운송비는 발송인 부담하고 나머지는 수취인부담
                            // 관세선납이 true거나 FedEx-E면 비토리지 납부
                            termsOfSale: needsCusPrepay ? "DDP" : "DAP",
                            shipmentPurpose: useType
                        },
                        totalCustomsValue: {
                            amount: totalCustomsValue,
                            currency: parentCurrency
                        },
                        ...(customs.insrFl ? {
                            insuranceCharge: {
                                amount: customs.insrPrice,
                                currency: "KRW"
                            }
                        } : {}),
                        dutiesPayment: {
                            // cusPrepayFl이 true면 지불타입은 비토리지(SENDER)
                            paymentType: needsCusPrepay ? "SENDER" : "RECIPIENT",
                            ...(needsCusPrepay && {
                                payor: {
                                    responsibleParty: {
                                        contact: {
                                            "personName": "Btorage",
                                            "emailAddress": "help@btorage.com",
                                            "phoneNumber": "821033389354"
                                        },
                                        accountNumber: {"value": String(fedexLiveAccountNum)}
                                    }
                                }
                            })
                        },
                    },
                    requestedPackageLineItems: [{
                        sequenceNumber: String(row.seqNum),
                        weight: {units: "KG", value: totalWeightValue},
                        // row.shipInfoDTO.fedexPack === '1'이 아닐때만 가로*세로*높이 전송해야 오류 X
                        ...(row.shipInfoDTO.fedexPack !== '1' && {
                            dimensions: {
                                length: length,
                                width: width,
                                height: height,
                                units: "CM"
                            }
                        }),
                        itemDescription: customs.custContent.slice(0, 35),
                        declaredValue: {
                            amount: totalCustomsValue,
                            currency: parentCurrency
                        },
                        customerReferences: [
                            {customerReferenceType: "CUSTOMER_REFERENCE", value: order.orderNumber}
                        ],
                        groupPackageCount: 1,
                        packageSpecialServices: {
                            // 사인불필요
                            ...(!isSignatureRequiredCountry && {
                                signatureOptionType: "NO_SIGNATURE_REQUIRED"
                            })
                        }
                    }],
                    labelSpecification: {
                        labelFormatType: "COMMON2D",
                        labelStockType: "STOCK_4X675_LEADING_DOC_TAB",
                        imageType: "ZPLII",
                    },
                    // ETD(페덱스 생성/업로드)
                    shipmentSpecialServices: {
                        specialServiceTypes: activeSpecialServiceTypes, // ETD & 배송알림 사용 활성화
                        etdDetail: {
                            requestedDocumentTypes: ["COMMERCIAL_INVOICE"] // 페덱스가 대신 생성
                        }
                    },
                    // 수취인 이메일로 배송과정 알림
                    ...(isDeliveryAlarm && {
                        emailNotificationDetail: {
                            aggregationType: "PER_SHIPMENT", // 배송 단위 알림
                            emailNotificationRecipients: [
                                {
                                    emailNotificationRecipientType: "RECIPIENT", // 수취인에게 발송
                                    ...(isDeliveryAlarm && { emailAddress: member.id }), // 수취인 이메일 주소
                                    notificationFormatType: "HTML",
                                    name: recname,
                                    locale: "en_US",
                                    notificationType: "EMAIL",
                                    // 알림 받을 이벤트: 발송됨, 배송완료, 예외발생
                                    notificationEventType: ["ON_SHIPMENT", "ON_DELIVERY", "ON_EXCEPTION"]
                                }
                            ]
                        },
                    }),
                    // 레터헤드/서명
                    shippingDocumentSpecification: {
                        shippingDocumentTypes: ["COMMERCIAL_INVOICE"],
                        commercialInvoiceDetail: {
                            // 인보이스는 PDF로(명시 안 하면 labelSpecification.imageType(ZPLII) 오류발생)
                            documentFormat: {
                                stockType: "PAPER_LETTER", // 용지크기
                                locale: "en_US",
                                docType: "PDF",
                            },
                            customerImageUsages: [{
                                id: "IMAGE_1",
                                type: "LETTER_HEAD",
                                providedImageType: "LETTER_HEAD"
                            }, {
                                id: "IMAGE_2",
                                type: "SIGNATURE",
                                providedImageType: "SIGNATURE"
                            }
                            ]
                        }
                    }
                },
                labelResponseOptions: "LABEL", // ✅ 올바른 값
                accountNumber: {
                    value: String(fedexLiveAccountNum)
                },
                // 배송료 원화청구
                preferredCurrency: "KRW",
                shipAction: "CONFIRM"
            };
        }));
    };

    // Zebra 프린터로 ZPL 데이터를 전송하는 함수
    const printZplWithBrowserPrint = (zplData) => {
        try {
            // Base64 디코딩
            const decodedZpl = atob(zplData);

            // Zebra Browser Print가 PC에 설치되어 있는지 확인
            window.BrowserPrint.getDefaultDevice("printer", (device) => {
                if (device) {
                    // ZPL 데이터를 프린터로 전송
                    device.send(decodedZpl,
                        () => console.log("인쇄 성공!"),
                        (error) => console.error("인쇄 실패:", error)
                    );
                } else {
                    alert("Zebra 프린터가 연결되지 않았거나 Browser Print가 실행 중이 아닙니다.");
                }
            }, (error) => {
                console.error("Browser Print 오류:", error);
                alert("Zebra Browser Print 소프트웨어와 통신할 수 없습니다. 설치 및 실행 여부를 확인해주세요.");
            });
        } catch (e) {
            console.error("Base64 디코딩 또는 인쇄 중 오류 발생", e);
            alert("라벨 데이터를 처리하는 중 오류가 발생했습니다.");
        }
    };

    // UPS API
    const [upsErrorList, setUpsErrorList] = useState([]);
    const upsConnectApi = async () => {
        if (isLoading) return;

        setIsLoading(true);
        setUpsErrorList([]);
        const fetchData = await fetchUpsData();

        if (fetchData.length === 0) return;

        const query = new URLSearchParams({additionaladdressvalidation: 'string'}).toString();

        try {
            const response = await axios({
                method: 'post',
                url: `/externalApi/upsReceipt?${query}`,
                data: fetchData,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: LCAT
                }
            });

            const data = response.data;
            let successCount = 0;
            let errorList = [];
            // ✅ 성공한 결과를 모을 배열 선언
            let successResultsForExcel = [];

            for (const result of data) {
                if (result.error) {
                    // 실패 항목 저장
                    errorList.push({
                        seqNum: result.paySeqNum,
                        code: result.errorCode,
                        message: result.errorMessage
                    });
                } else {
                    // 성공 처리
                    try {
                        await sendMessage(result);
                        console.log("result : ", result)
                        await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: result?.orderdtDTO?.memberDTO?.mbNum}));
                        successCount++;
                        // ✅ 성공한 건을 엑셀용 배열에 추가
                        successResultsForExcel.push(result);
                    } catch (err) {
                        console.error("메시지 전송 오류:", err);
                    }
                }
            }

            // 결과 요약
            if (errorList.length > 0) {
                setUpsErrorList(errorList); // 오류 상태 업데이트
            } else {
                setUpsErrorList([]); // 오류 없으면 초기화
            }

            // ✅ API 처리가 다 끝나고 성공한 건이 있다면 엑셀 다운로드 실행
            if (successResultsForExcel.length > 0) {
                await handleDownloadUpsExcel(successResultsForExcel);
            }

        } catch (error) {
            console.error('UPS API 요청 실패:', {
                message: error.message,
                data: error.response?.data,
                status: error.response?.status,
            });

            const errorResponse = error.response?.data;
            if (errorResponse?.error) {
                setUpsErrorList([
                    {
                        seqNum: '전체',
                        code: errorResponse.errorCode || 'UNKNOWN',
                        message: errorResponse.errorMessage || 'UPS API 오류'
                    }
                ]);
            } else {
                setUpsErrorList([
                    {
                        seqNum: '전체',
                        code: 'NETWORK',
                        message: '서버 응답 실패 또는 네트워크 오류'
                    }
                ]);
            }
        } finally {
            setAlertShowUps(false);
            setIsLoading(false);
            window.scrollTo({top: 0, behavior: 'smooth'});
            if (upsErrorList.length === 0) {
                // 추후 추가쿼리 날리지 않고 반환된 접수 seqNum === 접수리스트 데이터 seqNum 매칭 후 업뎃
                ordReceiptSelect();
            }
        }
    };

    // UPS 접수양식필드
    const fetchUpsData = async () => {
        const selected = ordReceiptData.filter((apiData) => checked.includes(apiData.seqNum));

        return await Promise.all(selected.map(async (apiData) => {
            const {address1, address2, address3, zipcode, recname, city} = apiData.appRecDTO;
            const countryCode = apiData.appRecDTO.countryDTO.countryCode;
            const recipientEmail = apiData.orderdtDTO.memberDTO.id || "";

            // GlobalTaxInformation필드(인도네시아 Tax ID 필수)를 위한 타입지정
            const rawTaxId = apiData.appRecDTO.taxid || '';
            const hasIndoTaxId = (countryCode === 'ID' && rawTaxId.trim().length > 0);
            const taxIdValue = hasIndoTaxId ? rawTaxId.trim() : null;
            // U0(선물), U1(개인물품) -> Consumer('02'), 그 외 -> Business('01')
            const useType = apiData.orderdtDTO.useType;
            const isConsumer = (useType === "U0" || useType === "U1");
            const isDeliveryAlarm = apiData.appReqDTO?.deliveryAlarm === true;
            // '01'은 사업체, '02'는 개인고객
            const consigneeTypeValue = isConsumer ? "02" : "01";
            // IDNumberTypeCode: AgentRole이 30일 때 유효값 (1002: Business, 0005: Personal Tax ID)
            const idNumberTypeCode = isConsumer ? "0005" : "1002";

            const fullAddress = [address1, address2, address3].filter(Boolean).join(' ');
            const addressLines = []; // UPS 필드명 'AddressLine'에 맞춰 변수명 변경
            let remainingAddress = fullAddress.trim();
            const maxLines = 3; // UPS도 보통 3줄까지 지원
            const maxLength = 35;

            while (remainingAddress.length > 0 && addressLines.length < maxLines) {
                if (remainingAddress.length <= maxLength) {
                    addressLines.push(remainingAddress);
                    remainingAddress = '';
                    break;
                }

                let splitIndex = remainingAddress.substring(0, maxLength + 1).lastIndexOf(' ');
                if (splitIndex <= 0) {
                    splitIndex = maxLength;
                }
                const line = remainingAddress.substring(0, splitIndex);
                addressLines.push(line);
                remainingAddress = remainingAddress.substring(splitIndex).trim();
            }

            const finalCity = remainingAddress.length > 0 ? `${remainingAddress} ${city}`.trim() : city;
            // const stateProvinceCode = (countryCode === 'US' || countryCode === 'CA' || countryCode === 'PR') ? await getStateCodeFromZip(zipcode, countryCode) : "";
            const stateProvinceCode = "";

            const customs = apiData.customsDTO;
            const parentCurrency = customs.custCurrency || "USD"; // 부모 통화
            const customItems = customs.customItemsDTO || [];
            // 자식아이템들 세관신고금액 총합
            const totalItemsValue = customItems.reduce((sum, item) => sum + (item.ttPrice || 0), 0);

            let products;
            let totalCustomsValue;

            // CASE 1: 여러 상품이 있고 총합이 0보다 클 때
            if (customItems.length > 0 && totalItemsValue > 0) {
                products = customItems.map(item => {
                    // ✅ 단가계산
                    const qty = Number(item.quantity) || 0; // 자식아이템 개별 수량
                    const price = Number(item.price) || 0; // 자식아이템 개별 세관신고금액

                    // 단가 계산 후 소수점 3자리부터 절삭 (숫자) & 소숫점 2자리까지 기준으로 마지막 자릿수가 0이 아닐 때까지 절삭
                    const numericUnitPrice = Math.trunc(price * 100000) / 100000;

                    return {
                        Description: String(item.content).slice(0, 35),
                        Unit: {
                            Number: String(qty),
                            UnitOfMeasurement: {Code: "PCS"},
                            Value: String(numericUnitPrice) // 계산된 단가로 삽입 👈 수정됨
                        },
                        CommodityCode: String(item.hscode),
                        OriginCountryCode: "KR",
                    };
                });
                totalCustomsValue = totalItemsValue;

                // CASE 2: 단일 상품이거나 여러 상품이지만 가격 정보가 없을 때
            } else {
                // ✅ 단가계산
                const qty = Number(customs.custQty) || 0; // 총 수량
                const price = Number(customs.custPrice) || 0; // 총 세관신고금액

                // 금액을 수량만큼 나누고 & 단가 계산 후 소수점 3자리부터 절삭 (숫자) & 소숫점 2자리까지 기준으로 마지막 자릿수가 0이 아닐 때까지 절삭
                const numericUnitPrice = (qty > 0) ? Math.trunc((price / qty) * 100000) / 100000 : 0;

                products = [{
                    Description: String(customs.custContent).slice(0, 35),
                    Unit: {
                        Number: String(qty),
                        UnitOfMeasurement: {Code: "PCS"},
                        Value: String(numericUnitPrice) // 계산된 단가로 삽입
                    },
                    CommodityCode: String(customs.hscode || '000000'), // HSCODE 없을 경우 대비
                    OriginCountryCode: "KR",
                }];
                totalCustomsValue = customs.custPrice;
            }

            const reasonForExport = apiData.orderdtDTO.useType === "U0" ? "GIFT" :
                apiData.orderdtDTO.useType === "U1" ? "SOLD" : "SAMPLE";

            return {
                paySeqNum: apiData.seqNum,
                ShipmentRequest: {
                    Request: {RequestOption: 'nonvalidate', SubVersion: '2409'},
                    Shipment: {
                        ...(apiData.upsQuoteId && {
                            quoteID: apiData.upsQuoteId || "",
                        }),
                        Description: apiData.customsDTO.custContent,
                        ReferenceNumber: [
                            {
                                // Code는 자유도 있으나 통상 "PO"(구매번호)나 "IK"(Invoice) 등을 사용. 필요시 수정.
                                Code: "PO",
                                Value: String(apiData.orderdtDTO.orderNumber || '')
                            }
                        ],
                        Shipper: {
                            Name: 'IMEUNWOO', AttentionName: 'IMEUNWOO',
                            Phone: {Number: '8201033389354'},
                            ShipperNumber: upsLiveAccountNum,
                            EMailAddress: 'help@btorage.com',
                            Address: {
                                AddressLine: ['32-15, Yeongok-gil 42beon-gil'],
                                City: 'Gonjiam-eup GWANGJU-SI', PostalCode: '12722', CountryCode: 'KR'
                            }
                        },
                        ShipTo: {
                            Name: recname,
                            AttentionName: recname,
                            // 인도네시아(ID) 한정: UPS의 수취인 Tax ID 필수검증(오류 120218)은
                            // GlobalTaxInformation이 아닌 이 레거시 필드를 기준으로 판정하므로 함께 전송 필수
                            ...(hasIndoTaxId && {TaxIdentificationNumber: taxIdValue}),
                            Phone: {Number: String(apiData.appRecDTO.telnum)},
                            EMailAddress: recipientEmail || '',
                            Address: {
                                AddressLine: addressLines,
                                City: finalCity,
                                StateProvinceCode: stateProvinceCode,
                                PostalCode: String(zipcode),
                                CountryCode: countryCode
                            }
                        },
                        ...(hasIndoTaxId && {
                            GlobalTaxInformation: {
                                OriginCountryShipmentValue: "NA",
                                DestinationCountryShipmentValue: "NA",
                                ShipperTypeValue: "NA",
                                ConsigneeTypeValue: consigneeTypeValue, // '01'은 사업체, '02'는 개인고객
                                AgentTaxIdentificationNumber: [
                                    {
                                        AgentRole: "30", // 30 = CONSIGNEE (수취인)
                                        TaxIdentificationNumber: [
                                            {
                                                IdentificationNumber: taxIdValue, // 실제 Tax ID 값
                                                IDNumberCustomerRole: "18", // 18 = Consignee/Receiver Address
                                                IDNumberEncryptionIndicator: "0", // 0 = Not Encrypted
                                                IDNumberIssuingCntryCd: "ID", // 발행국가: 인도네시아
                                                IDNumberPurposeCode: "01", // 01 = Customs/Brokerage
                                                IDNumberRequestingCntryCd: "ID", // 요청국가: 인도네시아
                                                IDNumberTypeCode: idNumberTypeCode, // '1002'(Business) or '0005'(Personal)
                                                IncludeIDNumberOnShippingBrokerageDocs: "01" // 01 = Include
                                            }
                                        ]
                                    }
                                ]
                            }
                        }),
                        ShipFrom: {
                            Name: 'IMEUNWOO', AttentionName: 'IMEUNWOO',
                            Phone: {Number: '821033389354'},
                            Address: {
                                AddressLine: ['32-15, Yeongok-gil 42beon-gil'],
                                City: 'Gonjiam-eup GWANGJU-SI', PostalCode: '12722', CountryCode: 'KR'
                            }
                        },
                        PaymentInformation: {
                            ShipmentCharge: [
                                // 기본적으로 해외배송료는 발송인(비토리지)이 지불
                                {
                                    Type: '01', // 해외배송료
                                    BillShipper: {AccountNumber: upsLiveAccountNum}
                                },
                                // cusPrepayFl이 true면 관부가세도 발송인(비토리지)이 대납
                                // false일 경우 기본값(관부가세 수취인청구)
                                ...(apiData.appReqDTO.cusPrepayFl ? [{
                                    Type: '02', // 관부가세
                                    BillShipper: {AccountNumber: upsLiveAccountNum}
                                }] : [])
                            ]
                        },
                        Service: {
                            Code: apiData.dvType === "D11" ? '65' : apiData.dvType === "D17" ? '08' : '65'
                        },
                        // ✅ 국제양식 내부의 인보이스
                        ShipmentServiceOptions: {
                            InternationalForms: {
                                PaperlessDocumentIndicator: true, // 👈 서류 없는 문서 표시기(인보이스 전자업로드 전송)
                                FormType: "01", // 01: Commercial Invoice
                                TermsOfShipment: apiData.appReqDTO.cusPrepayFl === true ? "DDP" : "DAP", // DDP:운송비+관세 등 모든 비용을 발송인이 부담 | DAP:운송비는 발송인 부담하고 나머지는 수취인부담
                                InvoiceNumber: generateState() || '',
                                InvoiceDate: new Date().toISOString().slice(0, 10).replace(/-/g, ''), // YYYYMMDD
                                ReasonForExport: reasonForExport,
                                CurrencyCode: parentCurrency,
                                Product: products, // 자식아이템
                                // ✅ 총 세관신고정보
                                InvoiceLineTotal: {
                                    CurrencyCode: parentCurrency,
                                    MonetaryValue: String(totalCustomsValue),
                                },
                                // 세관자동신고(UPS 측 인보이스 자동 생성 및 업로드) 시 필수 - Missing contact information 오류 발생
                                Contacts: {
                                    SoldTo: {
                                        Name: recname,
                                        AttentionName: recname,
                                        Phone: {Number: String(apiData.appRecDTO.telnum)},
                                        EMailAddress: recipientEmail || '',
                                        Address: {
                                            AddressLine: addressLines,
                                            City: finalCity,
                                            StateProvinceCode: stateProvinceCode,
                                            PostalCode: String(zipcode),
                                            CountryCode: countryCode
                                        },
                                    },
                                },
                            },
                        },
                        // 수취인 이메일로 배송알림옵션
                        ...(recipientEmail && isDeliveryAlarm && {
                            Notification: [
                                {
                                    NotificationCode: "6", // 6: Ship Notification (발송 알림)
                                    EMail: {EMailAddress: [recipientEmail]}
                                },
                                {
                                    NotificationCode: "7", // 7: Exception Notification (예외 알림 - 선택사항)
                                    EMail: {EMailAddress: [recipientEmail]}
                                },
                                {
                                    NotificationCode: "8", // 8: Delivery Notification (배송완료 알림)
                                    EMail: {EMailAddress: [recipientEmail]}
                                },
                            ]
                        }),
                        // ✅ 패키지(소포물)
                        Package: {
                            Description: apiData.customsDTO.custContent,
                            Packaging: {Code: '02'},
                            Dimensions: {
                                UnitOfMeasurement: {Code: 'CM', Description: 'Centimeters'},
                                Length: String(apiData.shipInfoDTO.wid),
                                Width: String(apiData.shipInfoDTO.ver),
                                Height: String(apiData.shipInfoDTO.hei)
                            },
                            PackageWeight: {
                                UnitOfMeasurement: {Code: 'KGS', Description: 'Kilograms'},
                                Weight: String(apiData.shipInfoDTO.weight)
                            },
                            // ✅ 보험가입
                            ...(apiData.customsDTO.insrFl && {
                                PackageServiceOptions: {
                                    InsuredValue: {
                                        CurrencyCode: 'KRW',
                                        MonetaryValue: String(apiData.customsDTO.insrPrice)
                                    }
                                }
                            })
                        },
                        ShipmentRatingOptions: {
                            NegotiatedRatesIndicator: ''
                        },
                        LabelSpecification: {
                            LabelImageFormat: {Code: "ZPL", Description: "Zebra ZPL"},
                            HTTPUserAgent: "Mozilla/4.5"
                        }
                    }
                }
            };
        }));
    };

    // ✅ UPS 발송자료 엑셀
    const handleDownloadUpsExcel = async (successResults) => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('UPS 발송리스트');

            // 1. 헤더 정의 (A ~ AJ)
            const headers = [
                'PackageRef1', 'PackageRef2', 'ShipperAccount', 'ShipFromCompanyorName', 'ShipFromAttention',
                'ShipFromAddress1', 'ShipFromAddress2', 'ShipFromAddress3', 'ShipFromPhone', 'ShipFromCity',
                'ShipFromState', 'ShipFromZip', 'ShipFromCountry', 'ShipToCompanyorName', 'ShipToAttention',
                'ShipToTaxID', 'ShipToAddress1', 'ShipToAddress2', 'ShipToAddress3', 'ShipToPhone',
                'ShipToCity', 'ShipToState', 'ShipToZip', 'ShipToCountry', 'ServiceLevel',
                'NoOfPkg', 'PackageWeight', 'BillingTransportation', 'BillingDutyOption', 'PackageType',
                'GeneralDescriptOfGoods', 'CreateINV', 'API 전송건', 'BL_NO', 'Invoice Value', 'Currency'
            ];

            // 2. 제목 행 (1행) - 병합 및 스타일링
            worksheet.mergeCells('A1:AJ1');
            const titleRow = worksheet.getRow(1);
            const titleCell = titleRow.getCell(1);
            const todayStr = new Date().toISOString().slice(0, 10);

            titleCell.value = `UPS 발송자료 ${todayStr}`;
            titleCell.font = { name: 'Malgun Gothic', size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
            titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFBE48' } };
            titleCell.alignment = { vertical: 'middle', horizontal: 'left' };
            titleRow.height = 30;

            // 3. 컬럼 헤더 행 (2행) - 스타일링
            const headerRow = worksheet.addRow(headers);
            headerRow.height = 25;
            headerRow.eachCell((cell) => {
                cell.font = { name: 'Malgun Gothic', size: 11, bold: true, color: { argb: 'FF333333' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } }; // Light Gray
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }
                };
            });

            // 4. 데이터 매핑 및 삽입 (3행 ~ )
            // successResults는 API 응답값(트래킹번호 포함)입니다.
            // 이를 ordReceiptData(기존 화면 데이터)와 매칭해야 주소 정보를 가져올 수 있습니다.
            successResults.forEach((result) => {
                // paySeqNum으로 원본 데이터 찾기
                const origin = ordReceiptData.find(item => item.seqNum === result.paySeqNum);
                const stateCode = result.stateCode

                if (origin) {
                    const { appRecDTO, orderdtDTO, shipInfoDTO, customsDTO, appReqDTO } = origin;
                    const fullAddr = [appRecDTO.address1, appRecDTO.address2, appRecDTO.address3].filter(Boolean);

                    // UPS Service Code 매핑
                    const serviceCode = origin.dvType === "D11" ? '65' : origin.dvType === "D17" ? '08' : '65';
                    // 관부가세 납부주체
                    const taxPayer = appReqDTO.cusPrepayFl ? 'SHP' : 'REC';

                    // 값 계산
                    const totalValue = customsDTO.custPrice || 0;

                    // 엑셀 행 데이터 배열
                    const rowData = [
                        orderdtDTO.orderNumber || '',       // PackageRef1 (주문번호)
                        '',                                 // PackageRef2
                        upsLiveAccountNum,                  // ShipperAccount (변수명 upsLiveAccountNum 등 사용)
                        'Btorage',                          // ShipFromCompanyorName
                        'IMEUNWOO',                         // ShipFromAttention
                        '32-15, Yeongok-gil 42beon-gil',    // ShipFromAddress1
                        'Gonjiam-eup',                      // ShipFromAddress2
                        'Gyeonggi-do',                      // ShipFromAddress3
                        '8201033389354',                    // ShipFromPhone
                        'GWANGJU-SI',                       // ShipFromCity
                        '',                                 // ShipFromState
                        '12722',                            // ShipFromZip
                        'KR',                               // ShipFromCountry
                        appRecDTO.recname,                  // ShipToCompanyorName
                        appRecDTO.recname,                  // ShipToAttention
                        appRecDTO.taxid || '',              // ShipToTaxID
                        fullAddr[0] || '',                  // ShipToAddress1
                        fullAddr[1] || '',                  // ShipToAddress2
                        fullAddr[2] || '',                  // ShipToAddress3
                        appRecDTO.telnum,                   // ShipToPhone
                        appRecDTO.city,                     // ShipToCity
                        stateCode || '',                    // ShipToState
                        appRecDTO.zipcode,                  // ShipToZip
                        appRecDTO.countryDTO.countryCode,   // ShipToCountry
                        serviceCode,                        // ServiceLevel
                        1,                                  // NoOfPkg
                        shipInfoDTO.weight,                 // PackageWeight
                        'SHP',                              // BillingTransportation
                        taxPayer,                           // BillingDutyOption (관부가세 납부주체)
                        '02',                               // PackageType (Customer Packaging)
                        customsDTO.custContent,             // GeneralDescriptOfGoods
                        'Y',                                // CreateINV
                        'API',                              // API 전송건
                        result.outWayNum || '',             // BL_NO (트래킹번호)
                        totalValue,                         // Invoice Value
                        'USD'                               // Currency
                    ];

                    const row = worksheet.addRow(rowData);

                    // 데이터 행 스타일링
                    row.eachCell((cell) => {
                        cell.font = { name: 'Malgun Gothic', size: 10 };
                        cell.alignment = { vertical: 'middle', horizontal: 'center' };
                        cell.border = {
                            top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }
                        };
                    });
                }
            });

            // 5. 컬럼 너비 자동 조정 (최소 12, 최대 30)
            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const columnLength = cell.value ? cell.value.toString().length : 0;
                    if (columnLength > maxLength) {
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < 12 ? 12 : (maxLength > 30 ? 30 : maxLength + 2);
            });

            // 6. 파일 다운로드
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `UPS_발송자료_${todayStr}.xlsx`);

        } catch (err) {
            console.error('Excel Generation Error:', err);
            alert('엑셀 파일 생성 중 오류가 발생했습니다.');
        }
    };

    const handleCopyToClipboard = () => {
        const getPriceByDvType = (data) => {
            switch (data.dvType) {
                case "D01":
                    return data.fedexPrice;
                case "D11":
                    return data.upsPrice;
                case "D02":
                    return data.emsPrice;
                case "D15":
                    return data.emsPrePrice;
                case "D13":
                    return data.kpackPrice;
                case "D03":
                    return data.seaPrice;
                case "D14":
                    return data.airSPrice;
                default:
                    return 0;
            }
        };

        const textToCopy = ordReceiptData.map((data) => {
            const name = data.orderdtDTO.memberDTO.userName;
            const price = getPriceByDvType(data);
            const reward = Math.floor((price * 0.05) / 10) * 10;
            return `${name} ${reward}`;
        }).join("\n");

        navigator.clipboard.writeText(textToCopy).then(() => {
            // 복사 성공 처리 (예: 토스트 메시지 등)
        }).catch((err) => {
            console.error("클립보드 복사 실패:", err);
        });
    };

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    // 배송사 필터 콤보박스가 변경되면 무조건 선택된 체크박스 이력 리셋
    useEffect(() => {
        setChecked([]);
        setShipcoChecked([]);
    }, [selectedShipCompany]);


    return (
        <div className="AdminReceiptList font-t-cont">
            <div className="admin-wrap-card text-center">
                <div className="Receipt-title"><p className="font-c-default font-t-title font-s-25">Receipt List</p>
                </div>
                <div style={{marginBottom: "20px"}}>
                    {emsErrorList.length > 0 && (
                        <div className="font-c-cancel font-s-14">
                            {emsErrorList.map((err, idx) => {
                                const matched = ordReceiptData.find(item => String(item.seqNum) === String(err.seqNum));
                                const orderLabel = matched ? `${matched.orderdtDTO?.orderNumber || '??'}-${matched.shipInfoDTO?.boxNum || '??'}` : `#${err.seqNum}`;
                                return (
                                    <div key={idx} style={{marginBottom: '4px'}}>
                                        ⚠ <b>{orderLabel}: </b>{err.message}<a> [Post Office : {err.code}]</a>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {fedexErrorList.length > 0 && (
                        <div className="font-c-cancel font-s-14">
                            {fedexErrorList.map((err, idx) => {
                                const matched = ordReceiptData.find(item => String(item.seqNum) === String(err.seqNum));
                                const orderLabel = matched ? `${matched.orderdtDTO?.orderNumber || '??'}-${matched.shipInfoDTO?.boxNum || '??'}` : `#${err.seqNum}`;
                                return (
                                    <div key={idx} style={{marginBottom: '4px'}}>
                                        ⚠ <b>{orderLabel}: </b>{err.message}<a> [FedEx : {err.code}]</a>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {upsErrorList.length > 0 && (
                        <div className="font-c-cancel font-s-14">
                            {upsErrorList.map((err, idx) => {
                                const matched = ordReceiptData.find(item => String(item.seqNum) === String(err.seqNum));
                                const orderLabel = matched ? `${matched.orderdtDTO?.orderNumber || '??'}-${matched.shipInfoDTO?.boxNum || '??'}` : `#${err.seqNum}`;
                                return (
                                    <div key={idx} style={{marginBottom: '4px'}}>
                                        ⚠ <b>{orderLabel}: </b>{err.message}<a> [UPS : {err.code}]</a>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {errorInvoiceMsg &&
                        <div className="font-c-cancel font-s-14">
                            <div style={{marginBottom: '4px'}}>
                                ⚠ <a>errorInvoiceMsg</a>
                            </div>
                        </div>
                    }
                </div>
                <div style={{padding: "0 1rem 1rem 1rem"}}>
                    <div className="admin-event-wrap m-b-15">
                        <div className="admin-event-wrap-btn">
                            <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                            <div style={{marginRight: "15px"}}>
                                <select className="admin-combo p-l-7 font-s-14"
                                        style={{width: "110px", height: "1.78rem"}}
                                        onChange={(e) => setSelectedShipCompany(e.target.value)}>
                                    <option value="">배송사선택</option>
                                    {/*<option value="D01">FedEx</option>*/}
                                    {/*<option value="D16">FedEx-E</option>*/}
                                    {/*<option value="D11">UPS</option>*/}
                                    {/*<option value="D17">UPS-E</option>*/}
                                    <option value="FedEx_Group">FedEx</option>
                                    <option value="UPS_Group">UPS</option>
                                    <option value="D02">EMS</option>
                                    <option value="D15">EMSP</option>
                                    <option value="D03">Sea</option>
                                    <option value="D04">DHL</option>
                                    <option value="D13">K-Packet</option>
                                    <option value="D14">Small-Packet</option>
                                    <option value="D00">국내배송</option>
                                </select>
                            </div>
                            <button className="admin-btn-B wd-120 ht-30 font-s-13 btn-click-event"
                                    onClick={handleCopyToClipboard}>적립금복사(임시)
                            </button>
                        </div>
                        <div className="admin-event-wrap-btn gap7">
                            <label className="font-s-13 m-t-7 m-r-3">출고접수 양식 다운로드</label>
                            <button className="admin-btn-B wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={() => excelDownFedex()}>EXCEL[FedEx]
                            </button>
                            <button className="admin-btn-B wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={() => excelDownEms()}>EXCEL[EMS]
                            </button>
                            <button className="admin-btn-B wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={() => excelDownSPack()}>EXCEL[S-P]
                            </button>
                            <button className="admin-btn-B wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={() => excelDownSea()}>EXCEL[Sea]
                            </button>
                            <button className="admin-btn-C wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                    onClick={invoiceDown}>INVOICE[공통]
                            </button>
                        </div>
                    </div>
                    <div className="div-tb m-b-20">
                        <div className="div-tb-head ht-90">
                            <div style={{width: "45px", textAlign: "right", paddingRight: "5px"}}>
                                <input className="admin-input-chkBox m-0-a" type="checkbox"
                                       checked={filteredData.length > 0 && filteredData.every(item => checked.includes(item.seqNum))}
                                       onChange={allcheckBoxChange}
                                />
                            </div>
                            <div style={{width: "215px"}}><p>주문번호</p></div>
                            <div style={{width: "170px"}}>
                                <p>고객명</p>
                                <p>수취인명</p>
                            </div>
                            <div style={{width: "120px"}}>
                                <p>국가</p>
                                <p>상세주소</p>
                            </div>
                            <div style={{width: "100px"}}>
                                <p>총상품수량</p>
                                <p>상품상세</p>
                            </div>
                            <div style={{width: "120px"}}><p>총상품금액</p></div>
                            <div style={{width: "150px"}}>
                                <p>배송사</p>
                                <p>운송장번호</p>
                                <p>운임료</p>
                            </div>
                            <div style={{width: "250px"}}>
                                <p>세관신고금액</p>
                                <p>내용품명</p>
                            </div>
                            <div style={{width: "180px", paddingTop: "7px"}}>
                                <p>부피중량</p>
                                <p>적용중량</p>
                                <p>배송비용(&#8361;)</p>
                            </div>
                        </div>
                        {/*{ordReceiptData.filter((cData) => selectedShipCompany === '' || cData.dvType === selectedShipCompany).map((rData, i) => {*/}
                        {currentItems.map((rData, i) => {
                            let totalQty = 0;
                            let totalPrice = 0;

                            if (rData.packListDTO && rData.packListDTO.productsDTO) {
                                rData.packListDTO.productsDTO.forEach(product => {
                                    totalQty += product.quantity;
                                    totalPrice += (product.price + product.mallShipPrice);
                                });
                            }

                            return (
                                <div key={i} className="div-tb-body" style={{position: "relative", padding: "10px 0"}}>
                                    <div style={{width: "45px", textAlign: "right", paddingRight: "5px"}}>
                                        <input className="admin-input-chkBox m-0-a" type={"checkbox"}
                                               checked={checked.includes(rData.seqNum)}
                                               onChange={() => checkBoxChange(rData.seqNum, rData.dvType)}/>
                                    </div>
                                    <div style={{width: "215px"}}><p
                                        className="font-b">{rData.orderdtDTO.orderNumber} - {rData.shipInfoDTO.boxNum}</p>
                                    </div>
                                    <div style={{width: "170px"}}>
                                        <p>{rData.orderdtDTO.memberDTO.userName}</p>
                                        <p className="font-b" style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                                            {rData.appRecDTO.recname}
                                        </p>
                                    </div>
                                    <div style={{width: "120px"}}>
                                        <p>{rData.appRecDTO.countryDTO.countryNm + " [" + rData.appRecDTO.countryDTO.countryCode + "]"}</p>
                                        <p>
                                            <button onClick={() => toggleMenu(rData.seqNum, 'rec')}
                                                    className="admin-btn-basic wd-40 ht-25 m-t-3"
                                                    style={{
                                                        position: "relative",
                                                        backgroundColor: recToggleSt[rData.seqNum] ? "rgb(255,203,109)" : "",
                                                        border: recToggleSt[rData.seqNum] ? "none" : ""
                                                    }}>
                                                {recToggleSt[rData.seqNum] ?
                                                    <RiArrowUpSFill style={{fontSize: "20px", marginBottom: "1px"}}/> :
                                                    <RiArrowDownSFill style={{fontSize: "20px", marginBottom: "1px"}}/>
                                                }
                                            </button>
                                            {recToggleSt[rData.seqNum] && (
                                                <div ref={menuRef} style={{
                                                    position: "absolute",
                                                    width: "550px",
                                                    top: "-148%",
                                                    left: 280,
                                                    height: "auto",
                                                    backgroundColor: "#ffffff",
                                                    padding: "7px",
                                                    zIndex: 10,
                                                    border: "solid 1px #dee2e6",
                                                    borderRadius: "7px",
                                                    boxShadow: "2px 2px 10px -5px"
                                                }}>
                                                    <div className="dt-box-cont">
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            height: "35px"
                                                        }}>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">우편번호</p></div>
                                                            <div style={{width: "30%"}}><p
                                                                className="font-b">{rData.appRecDTO.zipcode}</p></div>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">도시명</p></div>
                                                            <div style={{width: "30%"}}><p>{rData.appRecDTO.city}</p>
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            height: "35px"
                                                        }}>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA",}}><p
                                                                className="font-b">주소1</p></div>
                                                            <div style={{width: "80%"}}><p className="font-b"
                                                                                           style={{marginLeft: "15px"}}>{rData.appRecDTO.address1}</p>
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            height: "35px"
                                                        }}>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">주소2</p></div>
                                                            <div style={{width: "80%"}}><p className="font-b"
                                                                                           style={{marginLeft: "15px"}}>{rData.appRecDTO.address2}</p>
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            height: "35px"
                                                        }}>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">주소3</p></div>
                                                            <div style={{width: "80%"}}><p className="font-b"
                                                                                           style={{marginLeft: "15px"}}>{rData.appRecDTO.address3}</p>
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            height: "35px"
                                                        }}>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">연락처</p></div>
                                                            <div style={{width: "30%"}}><p>{rData.appRecDTO.telnum}</p>
                                                            </div>
                                                            <div style={{width: "20%", backgroundColor: "#FFF7EA"}}><p
                                                                className="font-b">Tax ID</p></div>
                                                            <div style={{width: "30%"}}><p>{rData.appRecDTO.taxid}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </p>
                                    </div>
                                    <div style={{width: "100px"}}>
                                        <p>{totalQty}개</p>
                                        <p>
                                            <button onClick={() => toggleMenu(rData.seqNum, 'prod')}
                                                    className="admin-btn-basic wd-40 ht-25 m-t-3"
                                                    style={{
                                                        position: "relative",
                                                        backgroundColor: prodToggleSt[rData.seqNum] ? "rgb(255,203,109)" : "",
                                                        border: prodToggleSt[rData.seqNum] ? "none" : ""
                                                    }}>
                                                {prodToggleSt[rData.seqNum] ?
                                                    <RiArrowUpSFill style={{fontSize: "20px", marginBottom: "1px"}}/> :
                                                    <RiArrowDownSFill style={{fontSize: "20px", marginBottom: "1px"}}/>
                                                }
                                            </button>
                                            {prodToggleSt[rData.seqNum] && (
                                                <div style={{
                                                    position: "absolute",
                                                    width: "500px",
                                                    top: "-178%",
                                                    left: 440,
                                                    height: '230px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '8px',
                                                    overflow: 'hidden',
                                                    fontFamily: 'sans-serif',
                                                    backgroundColor: '#fff',
                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                                                }}>
                                                    {/* 헤더 */}
                                                    <div style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: '85% 15%',
                                                        backgroundColor: '#FFF7EA',
                                                        padding: '6px 16px',
                                                        fontWeight: 'bold',
                                                        fontSize: '13px',
                                                        borderBottom: '1px solid #e0e0e0',
                                                        height: '42px',
                                                        alignItems: 'center'
                                                    }}>
                                                        <div>상품명</div>
                                                        <div style={{textAlign: 'right'}}>수량</div>
                                                    </div>

                                                    {/* 리스트 */}
                                                    <div style={{height: 'calc(230px - 42px)', overflowY: 'auto'}}>
                                                        {rData.packListDTO.productsDTO.map((product, i) => (
                                                            <div key={i}
                                                                 style={{
                                                                     display: 'grid',
                                                                     gridTemplateColumns: '85% 15%',
                                                                     padding: '8px 16px',
                                                                     fontSize: '13px',
                                                                     borderBottom: '1px solid #f0f0f0',
                                                                     alignItems: 'center'
                                                                 }}
                                                            >
                                                                <div style={{
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}>{product.name}</div>
                                                                <div
                                                                    style={{textAlign: 'right'}}>{product.quantity}</div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </p>
                                    </div>
                                    <div style={{width: "120px"}}><p>{'\u20A9'} {totalPrice.toLocaleString()}</p></div>
                                    <div style={{width: "150px"}}>
                                        <p className="font-b">
                                            {rData.dvType === "D00" ? "국내배송" :
                                                rData.dvType === "D01" ? "FedEx" :
                                                    rData.dvType === "D02" ? "EMS" :
                                                        rData.dvType === "D03" ? "Sea" :
                                                            rData.dvType === "D04" ? "DHL" :
                                                                rData.dvType === "D11" ? "UPS" :
                                                                    rData.dvType === "D13" ? "K-Packet" :
                                                                        rData.dvType === "D14" ? "Small-Packet" :
                                                                            rData.dvType === "D15" ? "EMSP" :
                                                                                rData.dvType === "D16" ? "FedEx-E" :
                                                                                    rData.dvType === "D17" ? "UPS-E" :
                                                                                        "N/A"}
                                        </p>
                                        <p>
                                            <input
                                                className="admin-input-line wd-120 ht-30 font-b font-c-progress font-s-12 text-center m-t-3 m-b-5"
                                                type="text" maxLength="16"
                                                value={rData.shipInfoDTO.outWayNum || ''} placeholder="운송장번호"
                                                onChange={(e) => handleInputWaybillChange(e, rData.seqNum)}
                                            />
                                        </p>
                                        <p>
                                            <input key={i} className="admin-input-line wd-120 ht-30 text-right p-r-5"
                                                   type="text" placeholder="0" maxLength="8"
                                                   value={(rData.shipInfoDTO.shipPrice ?? "").toString()}
                                                   onChange={(e) => handleInputPriceChange(e, rData.seqNum)}
                                            />
                                        </p>
                                    </div>

                                    <div style={{width: "250px"}}>
                                        {/*세관신고금액 & 통화*/}
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "baseline",
                                            gap: "6px",
                                            flexWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                        }}>
                                            <span
                                                className="font-b"
                                                style={{color: rData.customsDTO.custPrice > 800 ? "#E06974" : "#7EAAE6",}}>
                                                {rData.customsDTO.custPrice}
                                            </span>
                                            <span style={{fontSize: "11px"}}>{rData.customsDTO.custCurrency}</span>
                                        </div>
                                        {/*세관신고내용*/}
                                        <p>{rData.customsDTO.custContent}</p>
                                    </div>

                                    <div style={{width: "180px"}}>
                                        <p>{rData.shipInfoDTO.wid} x {rData.shipInfoDTO.ver} x {rData.shipInfoDTO.hei} - {rData.shipInfoDTO.weight}kg</p>
                                        <p className="font-b" style={{color: "#6D6DB6"}}>
                                            {
                                                rData.dvType === "D00" ? rData.shipInfoDTO.domeApyWeight :
                                                    rData.dvType === "D01" ? rData.shipInfoDTO.fedexApyWeight :
                                                        rData.dvType === "D02" ? rData.shipInfoDTO.emsApyWeight :
                                                            rData.dvType === "D03" ? rData.shipInfoDTO.seaApyWeight :
                                                                rData.dvType === "D11" ? rData.shipInfoDTO.upsApyWeight :
                                                                    rData.dvType === "D13" ? rData.shipInfoDTO.kpackApyWeight :
                                                                        rData.dvType === "D14" ? rData.shipInfoDTO.airSApyWeight :
                                                                            rData.dvType === "D15" ? rData.shipInfoDTO.emsPreApyWeight :
                                                                                rData.dvType === "D16" ? rData.shipInfoDTO.fedexEcoApyWeight :
                                                                                    rData.dvType === "D17" ? rData.shipInfoDTO.upsEcoApyWeight :
                                                                                        0
                                            }
                                            kg
                                            {
                                                rData.dvType === "D01" &&
                                                rData.shipInfoDTO.wid === 0 &&
                                                rData.shipInfoDTO.ver === 0 &&
                                                rData.shipInfoDTO.hei === 0 &&
                                                ' [Pack]'
                                            }
                                        </p>
                                        <p className="font-b" style={{color: "#7EAAE6"}}>
                                            {'\u20A9'} {rData.dvType === "D00" ? rData.ttDomPrice.toLocaleString() :
                                            rData.dvType === "D01" ? rData.ttFedexPrice.toLocaleString() :
                                                rData.dvType === "D02" ? rData.ttEmsPrice.toLocaleString() :
                                                    rData.dvType === "D03" ? rData.ttSeaPrice.toLocaleString() :
                                                        rData.dvType === "D11" ? rData.ttUpsPrice.toLocaleString() :
                                                            rData.dvType === "D13" ? rData.ttKPackPrice.toLocaleString() :
                                                                rData.dvType === "D14" ? rData.ttAirSPrice.toLocaleString() :
                                                                    rData.dvType === "D15" ? rData.ttEmsPrePrice.toLocaleString() :
                                                                        rData.dvType === "D16" ? rData.ttFedexEcoPrice.toLocaleString() :
                                                                            rData.dvType === "D17" ? rData.ttUpsEcoPrice.toLocaleString() :
                                                                                0}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="text-right">
                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                onClick={alertTariff}>세관내용수정
                        </button>
                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                onClick={alertWaybill}>수동출고
                        </button>
                        <button className="admin-btn-C wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                onClick={alertFedexApi}>FEDEX API
                        </button>
                        <button className="admin-btn-C wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                onClick={alertUpsApi}>UPS API
                        </button>
                        <button className="admin-btn-C wd-100 ht-30 font-s-13 btn-click-event m-r-7"
                                onClick={alertPostOfficeApi}>POST API
                        </button>
                    </div>
                </div>
            </div>
            {isLoading && <CommonLoading/>}
            {alertShow === true ?
                <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel1} eventHandle2={outWaybillUpdate}
                                msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShowFedex === true ? <MsgSelectModal alertShow={alertShowFedex} eventHandle1={modalCancelFedex}
                                                       eventHandle2={fedexConnectApi} msgData1={msgConfirmFedexData1}
                                                       msgData2={msgConfirmEmsData2}/> : null}
            {alertShowUps === true ?
                <MsgSelectModal alertShow={alertShowUps} eventHandle1={modalCancelUps} eventHandle2={upsConnectApi}
                                msgData1={msgConfirmUpsData1} msgData2={msgConfirmEmsData2}/> : null}
            {alertShowEms === true ?
                <MsgSelectModal alertShow={alertShowEms} eventHandle1={modalCancelEms} eventHandle2={emsConnectApi}
                                msgData1={msgConfirmEmsData1} msgData2={msgConfirmEmsData2}/> : null}
            {nonEmsDataSt ? <MsgCheckModal nonEmsDataSt={nonEmsDataSt} closeNonEmsDataSt={closeNonEmsDataSt}/> : null}
            {nonSPackDataSt ?
                <MsgCheckModal nonSPackDataSt={nonSPackDataSt} closeNonSPackDataSt={closeNonSPackDataSt}/> : null}
            {nonSeaDataSt ? <MsgCheckModal nonSeaDataSt={nonSeaDataSt} closeNonSeaDataSt={closeNonSeaDataSt}/> : null}
            {nonFedexDataSt ?
                <MsgCheckModal nonFedexDataSt={nonFedexDataSt} closeNonFedexDataSt={closeNonFedexDataSt}/> : null}
            {nonUpsDataSt ? <MsgCheckModal nonUpsDataSt={nonUpsDataSt} closeNonUpsDataSt={closeNonUpsDataSt}/> : null}
            {nonSelectOrderSt ? <MsgCheckModal nonSelectOrderSt={nonSelectOrderSt}
                                               closeNonSelectOrderSt={closeNonSelectOrderSt}/> : null}
        </div>
    );
}

export default AdminReceiptList
